import { useParams } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import S3FileUpload from "react-s3";
import { Buffer } from "buffer";
import { Workbook, WorkbookInstance } from "@fortune-sheet/react";
import "../../styles/page.css";
import {
  Flex,
  Text,
  Icon,
  Button,
  Modal,
  ModalOverlay,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  Menu,
  MenuButton,
  PopoverCloseButton,
  Box,
  MenuItem,
  ModalContent,
  MenuList,
  ModalHeader,
  ModalFooter,
  Select,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Spinner,
  Checkbox,
  FormControl,
  FormLabel,
  Switch,
  Tag,
  Avatar,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useMediaQuery,
  Input,
  VStack,
  InputGroup,
  InputRightElement,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import { useRef, useContext, useState, useEffect } from "react";
import {
  CheckIcon,
  ChevronDownIcon,
  DeleteIcon,
  EditIcon,
  HamburgerIcon,
} from "@chakra-ui/icons";
import swal from "sweetalert";
import { Url } from "../../store/global";

import moment from "moment";
import { BiTrash, BiFile, BiEdit, BiDotsVertical } from "react-icons/bi";
import AuthContext from "../../store/auth";
import { useHotkeys } from "react-hotkeys-hook";
import Breadcrumbs from "../../components/BreadCrumbs";
// import useSticky from "../../components/useSticky";

const S3_BUCKET = "kms-assets";
const REGION = "us-east-1";
const ACCESS_KEY = "AKIAQTH52T33TY6UHF7L";
const SECRET_ACCESS_KEY = "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";

const Page = () => {
  const toast = useToast();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const key = urlParams.get("key");
  let { pageSlug } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3,
  } = useDisclosure();
  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4,
  } = useDisclosure();
  const {
    isOpen: isOpen6,
    onOpen: onOpen6,
    onClose: onClose6,
  } = useDisclosure();

  const {
    isOpen: isOpen7,
    onOpen: onOpen7,
    onClose: onClose7,
  } = useDisclosure();

  const {
    isOpen: isOpen8,
    onOpen: onOpen8,
    onClose: onClose8,
  } = useDisclosure();
  const {
    isOpen: isOpen9,
    onOpen: onOpen9,
    onClose: onClose9,
  } = useDisclosure();

  const { isOpen: isOpen5, onToggle: onToggle5 } = useDisclosure();

  const logoutHandler = () => {
    authCtx.logout();
  };
  window.Buffer = Buffer;

  const [d1, setD1] = useState();
  const [d2, setD2] = useState();
  const [switchVal, setSwitchVal] = useState();
  const [showSheet, setShowSheet] = useState();
  const [sheetData, setSheetData] = useState([]);
  const [hasChanged, setHasChanged] = useState(1);
  const [projectTitles, setProjectTitles] = useState();
  const [editValue, setEditValue] = useState("");
  const [dropdown, setDropdown] = useState();

  const [app, setApp] = useState(false);
  const [isCollab, setCollab] = useState(false);
  const [toggleState, setToggleState] = useState(false);
  const [fileImages, setFileImages] = useState(null);
  const [filel, setFilel] = useState(false);

  const handleRemoveItem = (arr, key, id) => {
    var arry = d1;
    if (arr === 1) {
      arry = d1;
      arry.splice(key, 1);
      setD1(arry);
      setHasChanged(hasChanged + 1);
      fetch({ Url }.Url + "/delete_page_links/", {
        method: "POST",
        body: JSON.stringify({
          type: "this_page_depends_on",
          page_id: pageSlug,
          deleted_id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }).then((response) =>
        response
          .json()
          .then((data) => ({
            data: data,
            status: response.status,
          }))
          .then((res) => {
            if (res.status < 300) {
              // console.log(res.data);
            } else {
              toast({
                title: "Oops, something went wrong!",
                description: res.data.detail,
                status: "error",
                duration: 2000,
                isClosable: true,
                position: "top-right",
              });

              // swal("Oops, something went wrong!", res.data.detail, "error");
            }
          })
      );
    }
    if (arr === 2) {
      arry = d2;
      arry.splice(key, 1);
      setD2(arry);
      setHasChanged(hasChanged + 1);
      fetch({ Url }.Url + "/delete_page_links/", {
        method: "POST",
        body: JSON.stringify({
          type: "page_that_depend_on_this_page",
          page_id: pageSlug,
          deleted_id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }).then((response) =>
        response
          .json()
          .then((data) => ({
            data: data,
            status: response.status,
          }))
          .then((res) => {
            if (res.status < 300) {
              // console.log(res.data);
            } else {
              toast({
                title: "Oops, something went wrong!",
                description: res.data.detail,
                status: "error",
                duration: 2000,
                isClosable: true,
                position: "top-right",
              });
              // swal("Oops, something went wrong!", res.data.detail, "error");
            }
          })
      );
    }
  };

  const [pageInfo, setPageInfo] = useState();
  const btnRef = useRef();
  const btnRef2 = useRef();
  const authCtx = useContext(AuthContext);

  const contentRef = useRef(null);
  const searchText = key;

  useEffect(() => {
    // console.log(searchText);
    if (!searchText || searchText.trim() === "") {
      return;
    }
    if (!contentRef.current) {
      return;
    }
    const highlightSearchText = (node) => {
      const textNodes = Array.from(node.childNodes).filter(
        (child) => child.nodeType === 3
      );

      textNodes.forEach((textNode) => {
        const textContent = textNode.textContent;
        const searchRegex = new RegExp(searchText, "gi");
        const matches = Array.from(textContent.matchAll(searchRegex));
        if (matches.length === 0) {
          return;
        }

        let newContent = textContent;
        let offset = 0;

        matches.forEach((match) => {
          const highlightedMatch = `<mark>${match[0]}</mark>`;
          newContent =
            newContent.slice(0, match.index + offset) +
            highlightedMatch +
            newContent.slice(match.index + offset + match[0].length);

          offset += highlightedMatch.length - match[0].length;
        });

        const newNode = document.createElement("span");
        newNode.innerHTML = newContent;
        textNode.replaceWith(newNode);
      });
    };

    const container = contentRef.current;
    const textElements = Array.from(container.getElementsByTagName("*"));
    const firstHighlightedElement = container.querySelector("mark");

    if (firstHighlightedElement) {
      firstHighlightedElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    textElements.forEach(highlightSearchText);
  }, [pageInfo]);
  const removeHighlightAndClearQueryParam = () => {
    const container = contentRef.current;
    const highlightedElements = container?.querySelectorAll("mark");

    highlightedElements.forEach((element) => {
      const parent = element.parentNode;
      parent.replaceChild(element.firstChild, element);
      parent.normalize();
    });

    let url = window.location.pathname.split("?")[0];
    window.history.replaceState({ path: url }, "", url);
  };

  useEffect(() => {
    const handleClick = () => {
      removeHighlightAndClearQueryParam();
    };

    const handleTimeout = () => {
      removeHighlightAndClearQueryParam();
    };

    window.addEventListener("click", handleClick);

    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState("");
  // new project modal
  const title = useRef(null);
  const [fiti, setFiti] = useState(null);

  function handleDragOver(event) {
    event.preventDefault();
    setIsDragging(true);
  }

  function handleDragLeave(event) {
    event.preventDefault();
    setIsDragging(false);
  }

  function handleFileDrop(event) {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    handleFileInput(file);
  }

  const onFileChange = (file) => {
    const config = {
      bucketName: S3_BUCKET,
      dirName: "media/public/uploads",
      region: REGION,
      accessKeyId: ACCESS_KEY,
      secretAccessKey: SECRET_ACCESS_KEY,
    };
    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        // console.log(data);
        // console.log(data.key);
        let a = data.key.lastIndexOf("/") + 1;
        let b = data.key.substring(a);
        // console.log(b);
        setFiti(b);
        setFilel(false);
        setFileURL(data.location);
      })
      .catch((err) => {
        alert(err);
        return null;
      });
  };

  const [initialRender, setInitialRender] = useState(true);
  useEffect(() => {
    if (initialRender) setInitialRender(false);
    else {
      onFileChange(selectedFile);
      setFilel(true);
    }
    // eslint-disable-next-line
  }, [selectedFile]);

  // new project modal

  const [files, setFiles] = useState([]);

  const handleNewFile = () => {
    const prev = files;
    prev.push({
      title: fiti,
      description: descRef.current.value,
      file: fileURL,
    });
    setFiles(prev);
    setFileURL(null);
    onClose();
    editPageHandler();
  };

  const descRef = useRef();

  const [fileURL, setFileURL] = useState(null);

  const handleFileInput = (e) => {
    setFileName(e.name);

    setSelectedFile(e);
    // console.log(e);
  };

  const descRef2 = useRef();
  const fiTitle = useRef();
  const fileRef = useRef();

  function sendGoogleDoc() {
    const abc = fileRef.current.value;
    const def = descRef2.current.value;
    const xyz = fiTitle.current.value;
    const prev = files;
    prev.push({
      title: xyz,
      description: def,
      file: abc,
    });
    editPageHandler();
    // setFiles(prev);
    // onClose2();
    // fetch('https://fj.orangeyak.xyz/api/core/add_google_doc/', {
    //   method: 'POST',
    //   body: JSON.stringify({
    //     page_id: pageSlug,
    //     file: abc,
    //     description: def,
    //     title: xyz,
    //   }),
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: 'Token ' + authCtx.token,
    //   },
    // }).then((response) =>
    //   response
    //     .json()
    //     .then((data) => ({
    //       data: data,
    //       status: response.status,
    //     }))
    //     .then((res) => {
    //       if (res.status < 300) {
    //         swal('Doc added Successfully!', "Let's head back to editing..", 'success');
    //         window.location.reload();
    //       } else {
    //         swal('Adding file failed.', res.data.detail, 'error');
    //       }
    //     })
    // );
  }

  const descRef3 = useRef();
  const titleRef3 = useRef();
  const [currDesc, setCurrDesc] = useState(null);
  const [currTitle, setCurrTitle] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);
  const [collapseVal, setCollapseVal] = useState();
  const [currId, setCurrId] = useState(null);

  function fileEditHandler(ti, desc, id) {
    setCurrDesc(desc);
    setCurrTitle(ti);
    setCurrId(id);
    // console.log(currDesc);
    onOpen3();
  }
  const [count, setCount] = useState(1);

  const removeFile = (id) => {
    const rand = files;
    // console.log(rand);
    rand.splice(id, 1);
    // console.log(rand);
    setFiles(rand);
    setCount(count + 1);
  };

  function editFile() {
    const desc = descRef3.current.value;
    // console.log(currId, desc, currTitle);
    fetch({ Url }.Url + "/edit_file/", {
      method: "POST",
      body: JSON.stringify({
        file_id: files[currId].id,
        title: titleRef3.current.value,
        description: desc,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "File edited Successfully!",
              description: "Let's head back to editing..",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal('File edited Successfully!', "Let's head back to editing..", 'success');
            getPageInformation();
          } else {
            toast({
              title: "Editing file failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal('Editing file failed.', res.data.detail, 'error');
          }
        })
    );

    onClose3();
  }

  function editPageHandler() {
    // const rtitle = title.current.value;

    if (pageInfo) {
      fetch({ Url }.Url + "/edit_page/" + pageSlug + "/", {
        method: "POST",
        body: JSON.stringify({
          title: pageInfo.title,
          key_findings: pageInfo?.key_findings,
          files: files,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }).then((response) =>
        response
          .json()
          .then((data) => ({
            data: data,
            status: response.status,
          }))
          .then((res) => {
            if (res.status < 300) {
              toast({
                title: "Block edited Successfully!",
                description: "Block edited Successfully!",
                status: "success",
                duration: 500,
                isClosable: true,
                position: "top-right",
                onCloseComplete: () => {
                  window.location.reload();
                },
              });

              // swal('Block edited Successfully!', "Let's head over to the block.", 'success', { timer: 3000 }).then(() => (window.location = '/page/' + res.data.page_id));
            } else {
              toast({
                title: "Editing failed.",
                description: "Something went wrong.",
                status: "error",
                duration: 2000,
                isClosable: true,
                position: "top-right",
              });
              // swal('Editing failed.', 'Something went wrong.', 'error');
            }
          })
      );
    }
  }
  function convert2DTo1D(matrix) {
    const result = [];

    for (let r = 0; r < matrix.length; r++) {
      for (let c = 0; c < matrix[r].length; c++) {
        const v = matrix[r][c];
        if (v) result.push({ r, c, v });
      }
    }

    return result;
  }

  function makeData(data) {
    if (data === {}) {
    } else {
      console.log("function makeData", data);
      const data1 = convert2DTo1D(data[0].data);
      console.log("data1", data1);
      data[0].celldata = data1;

      setSheetData(data);
    }
  }

  const getPageInformation = () => {
    fetch({ Url }.Url + "/get_page/" + pageSlug + "/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setPageInfo(res.data);
            console.log(res.data);
            console.log(res.data.key_findings_spreadsheet);
            setCollapseVal(res.data?.collapse_value);
            const sampleData = [
              {
                name: "Cell",
                id: "0",
                zoomRatio: 1,
                order: "0",
                column: 18,
                addRows: 70,
                row: 36,
                status: 1,
                celldata: [
                  {
                    r: 0,
                    c: 0,
                    v: {
                      v: "",
                      ct: {
                        fa: "General",
                        t: "g",
                      },
                      m: "",
                    },
                  },
                ],
                ch_width: 2321,
                rh_height: 936,
                luckysheet_select_save: [
                  {
                    left: 741,
                    width: 138,
                    top: 796,
                    height: 19,
                    left_move: 741,
                    width_move: 138,
                    top_move: 796,
                    height_move: 19,
                    row: [33, 33],
                    column: [6, 6],
                    row_focus: 33,
                    column_focus: 6,
                  },
                ],
                calcChain: [
                  {
                    r: 0,
                    c: 3,
                    id: "0",
                    func: [true, 3, "=Formula!A1+Formula!B1"],
                    color: "w",
                    parent: null,
                    chidren: {},
                    times: 0,
                  },
                ],
                scrollLeft: 0,
                scrollTop: 0,
              },
            ]
            if (res.data?.key_findings_spreadsheet[0]) 
            {
              if(res.data?.key_findings_spreadsheet[0]===sampleData) setShowSheet(false);
              else {makeData(res.data?.key_findings_spreadsheet);
              setShowSheet(true);}
            }
              else setSheetData(sampleData);
              
            // setSheetData(res.data.key_findings_spreadsheet);
            setKeyFindingsChanges(res.data.key_findings);
            setSwitchVal(false);
            // console.log(res.data.key_findings);
            setFileChanges(res.data.files);
            // get all image urls

            setEditValue(res.data.view_status);
            // console.log(res.data.view_status);
            // console.log(res.data);
            setD1(res.data.this_page_depends_on);
            setD2(res.data.pages_that_depend_on_this_page);
            setApp(res.data.approval_block_exists);
            setCollab(res.data.is_collaborator);
            setDropdown(res.data.dropdown_list);
            setFiles(res.data.files);

            setToggleState(res.data.subscriber);
            // console.log(res.data.subscriber);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  // console.log(pageInfo)
  const emailA = useRef();
  const subTreeBool = useRef();
  const subTreeBool2 = useRef();
  const projectA = useRef();

  const createApprovalPage = () => {
    fetch({ Url }.Url + "/create_approvals/", {
      method: "POST",
      body: JSON.stringify({
        page_id: pageSlug,
        approvers: emailA.current.value,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Approval Page created successfully!",
              description: "congratulations!",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/approval/" + pageSlug;
              },
            });
            // swal(
            //   "Approval Page created successfully!",
            //   "congratulations!",
            //   "success"
            // ).then(() => {
            //   window.location = "/approval/" + pageSlug;
            // });
          } else {
            toast({
              title: "Creating some approvers failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Creating some approvers failed.", res.data.detail, "error");
          }
        })
    );
  };

  const postToggleUpdate = () => {
    fetch({ Url }.Url + "/subscribe/" + pageSlug + "/", {
      method: "POST",
      body: JSON.stringify({
        value: toggleState,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log("all g");
          } else {
            // console.log("failed");
          }
        })
    );
  };

  const deleteHandler = () => {
    fetch({ Url }.Url + "/delete_page/" + pageSlug + "/", {
      method: "DELETE",
      body: JSON.stringify({
        subtree: subTreeBool2.current.checked,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Deletion confirmed.",
              description: "Let's head back to the project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location = "/project/" + pageInfo.project.id;
              },
            });
            // swal(
            //   "Deletion confirmed.",
            //   "Let's head back to the project.",
            //   "success"
            // ).then(() => {
            //   window.location = "/project/" + pageInfo.project.id;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  // copy a block
  function copyBlockHandler() {
    fetch({ Url }.Url + "/copy_page/" + pageSlug + "/", {
      method: "POST",
      body: JSON.stringify({
        project_id: projectA.current.value,
        copy_subtree: subTreeBool.current.checked,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Project Block Copied successfully!",
              description: "Let's head to the project.",
              status: "success",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: (value) => {
                switch (value) {
                  case "project":
                    window.location =
                      "/project/" + projectA.current.value + "/";
                    break;
                  default:
                    onClose2();
                    break;
                }
              },
            });

            // swal({
            //   title: "Project Block Copied successfully!",
            //   text: "Let's head to the project.",
            //   buttons: {
            //     cancel: "Close",
            //     project: "Go to project",
            //   },
            //   icon: "success",
            // }).then((value) => {
            //   switch (value) {
            //     case "project":
            //       window.location = "/project/" + projectA.current.value + "/";
            //       break;
            //     default:
            //       onClose2();
            //       break;
            //   }
            // });
            // window.location = "/project/" + res.data.project_id;
          } else {
            toast({
              title: "Copying failed.",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Copying failed.", res.data.detail, "error");
          }
        })
    );
    // console.log(subTreeBool.current.checked);
    // console.log(projectA.current.value);
  }

  // API GET request to query all the projects
  const getProjectTitles = () => {
    fetch({ Url }.Url + "/get_project_titles/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setProjectTitles(res.data.map((project) => project));
            // console.log(res.data);
            // console.log(dropdown);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  // runs on initial page load
  useEffect(() => {
    getPageInformation();
    getProjectTitles();
    // console.log("hi?");
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (pageInfo) {
  //     if (
  //       pageInfo?.project?.role?.toLowerCase() !== "viewer" &&
  //       pageInfo?.project?.role?.toLowerCase() !== "client"
  //     ) {
  //       getComments();
  //       getVersions();
  //     }
  //   }
  // }, [pageInfo]);

  useEffect(() => {
    postToggleUpdate();

    // eslint-disable-next-line
  }, [toggleState]);

  // shortcuts
  useHotkeys(
    "alt+x",
    () => (window.location = "/project/" + pageInfo.project.id)
  );
  useHotkeys(
    "option+x",
    () => (window.location = "/project/" + pageInfo.project.id)
  );
  useHotkeys("alt+b", () => (window.location = "/edit-page/" + pageSlug));
  useHotkeys("option+b", () => (window.location = "/edit-page/" + pageSlug));
  useHotkeys("alt+c", () => onOpen2());
  useHotkeys("option+c", () => onOpen2());
  useHotkeys("alt+p", () => (window.location = "/approval/" + pageSlug));
  useHotkeys("option+p", () => (window.location = "/approval/" + pageSlug));
  useHotkeys("alt+w", () => (window.location = "/edit-page/" + pageSlug));
  useHotkeys("option+p", () => (window.location = "/edit-page/" + pageSlug));
  const [isLargerThan1000] = useMediaQuery("(min-width: 1000px)");

  const breadcrumbs = [
    { path: "/", breadcrumb: "Home" },
    { path: "/library", breadcrumb: "Library" },
    {
      path: "/project/" + pageInfo?.project?.id,
      breadcrumb: pageInfo?.project?.title,
    },
  ];

  function editPageSessionBegin() {
    // console.log(rtitle, value.toString('html'), files)
    // console.log(pageInfo?.key_findings,value.toString('html'))
    fetch({ Url }.Url + "/edit_page_session/" + pageSlug + "/", {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            window.location = "/edit-page/" + pageSlug;
            // swal('Block edited Successfully!', "Let's head over to the block.", 'success', { timer: 3000 }).then(() => (window.location = '/page/' + res.data.page_id));
          } else {
            // console.log("error");
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  }

  // useEffect(()=>{
  //   window.onbeforeunload = function(e) {
  //     return 'Please press the Logout button to logout.';
  // };
  // },[])
  // comments for collaborators
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  // get comments
  const getComments = () => {
    setLoading(true);

    fetch({ Url }.Url + "/page_comments/" + pageSlug + "/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setComments(() => {
              const data = res.data;
              setLoading(false);
              return data;
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  // post comments

  const [comment, setComment] = useState("");
  const [replyValue, setReplyValue] = useState("");

  const postComment = (parent, comment) => {
    fetch({ Url }.Url + "/page_comments/" + pageSlug + "/", {
      method: "POST",
      body: JSON.stringify({
        comment: comment,
        parent: parent !== -1 ? parent : "",
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            getComments();
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  // delete comments
  const deleteComment = (id) => {
    fetch({ Url }.Url + "/page_comments/" + pageSlug + "/", {
      method: "DELETE",
      body: JSON.stringify({
        comment_id: id,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    })
      .then(() => getComments())
      .catch((err) => console.log(err));
  };

  // console.log(pageInfo);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editCommentValue, setEditCommentValue] = useState(null);
  const [addReviewId, setAddReviewId] = useState(null);
  const [showInput, setShowInput] = useState(false);

  const handleEditComment = (commentId) => {
    setEditingCommentId(commentId);
  };

  const handleSaveComment = (commentId, commentText) => {
    setLoading(true);
    fetch({ Url }.Url + "/page_comments/" + pageSlug + "/", {
      method: "PUT",
      body: JSON.stringify({
        comment: commentText,
        comment_id: commentId,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            setLoading(false);
            getComments();
            setEditingCommentId(null);
            setEditCommentValue(null);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const replyHandler = (commentId) => {
    setLoading(true);
    setAddReviewId(commentId);
    setShowInput(!showInput);
    setTimeout(() => {
      setLoading(false);
    }, 100);
  };
  const commentsEndRef = useRef(null);
  useEffect(() => {
    const boxElement = commentsEndRef.current;
    if (boxElement) {
      boxElement.scrollTop = boxElement.scrollHeight;
    }
  }, [comments]);

  // version history
  // get page versions
  const [versions, setVersions] = useState([]);
  const getVersions = () => {
    fetch({ Url }.Url + "/get_page_versions/" + pageSlug + "/", {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setVersions(res.data);
            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  const getVersion = (versionId) => {
    fetch(
      { Url }.Url +
        "/get_page_versions/" +
        pageSlug +
        "/?version_id=" +
        versionId,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            res?.data?.changes?.key_findings
              ? diffRenderFindings(
                  res.data.changes.key_findings?.old,
                  res.data.changes.key_findings?.new
                )
              : setKeyFindingsChanges(pageInfo?.key_findings);
            res?.data?.changes?.title
              ? diffRenderTitle(
                  res.data.changes.title?.old,
                  res.data.changes.title?.new
                )
              : setTitleChanges(pageInfo?.title);

            res?.data?.changes?.files?.old
              ? setFileChanges(res.data.changes.files?.old)
              : setFileChanges(pageInfo?.files);
            // console.log(res?.data?.changes?.files);
            // console.log(fileChanges);
            if (res?.data?.changes?.files?.old) {
              const { old, new: newFiles } = res?.data?.changes?.files;

              // Transform 'old' and 'new' arrays into objects for faster lookup
              const oldFilesObject = old?.reduce(
                (obj, file) => ({ ...obj, [file.file]: file }),
                {}
              );
              const newFilesObject = newFiles?.reduce(
                (obj, file) => ({ ...obj, [file.file]: file }),
                {}
              );
              const fileChangesNames = new Set(
                fileChanges.map((file) => file.file)
              );
              const oldNotInFileChanges = Object.keys(oldFilesObject).filter(
                (file) => !fileChangesNames.has(file)
              );

              // Map through 'fileChanges' to classify each file
              const fileStatus = fileChanges?.map((file) => {
                if (oldFilesObject[file.file] && newFilesObject[file.file]) {
                  return { ...file, version: "both" };
                } else if (oldFilesObject[file.file]) {
                  return { ...file, version: "old" };
                } else {
                  return { ...file, version: "new" };
                }
              });
              const additionalFiles = oldNotInFileChanges.map((file) => ({
                ...oldFilesObject[file],
                version: "old",
              }));

              // Combine the 'fileStatus' and 'additionalFiles' arrays
              const updatedFileChanges = [...fileStatus, ...additionalFiles];

              // console.log(updatedFileChanges);

              setFileChanges(updatedFileChanges);
            }

            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };
  function errorWorkbook() {
    toast({
      title: "Oops, something went wrong!",
      description: "Nothin",
      status: "error",
      duration: 2000,
      isClosable: true,
      position: "top-right",
    });
  }
  const putVersion = () => {
    fetch({ Url }.Url + "/backup_page/" + pageSlug + "/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            window.location.reload();
            // setComments(() => {
            //   const data = res.data;
            //   setLoading(false);
            //   return data;
            // });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const [keyFindingsChanges, setKeyFindingsChanges] = useState("");
  const [titleChanges, setTitleChanges] = useState("");
  const [fileChanges, setFileChanges] = useState(pageInfo?.files);

  function diffRenderTitle(oldTitle, newTitle) {
    let oldWords = oldTitle.split(" ");
    let newWords = newTitle.split(" ");

    const diffs = [];
    oldWords.forEach((oldWord, i) => {
      if (!newWords.includes(oldWord)) {
        diffs.push(
          `<span style="color: red;text-decoration:line-through">${oldWord}</span>`
        );
      } else if (newWords[i] !== oldWord) {
        diffs.push(
          `<span style="color: red;text-decoration:line-through">${oldWord}</span><span style="color: green">${newWords[i]}</span>`
        );
      } else {
        diffs.push(oldWord);
      }
    });

    newWords.forEach((newWord, i) => {
      if (
        !oldWords.includes(newWord) &&
        (i >= oldWords.length || newWords[i] !== oldWords[i])
      ) {
        diffs.push(`<span style="color: green">${newWord}</span>`);
      }
    });

    const diffsText = diffs.join(" ");
    setTitleChanges(diffsText);
    // console.log(diffsText);
  }

  function diffRenderFindings(oldText, newText) {
    const oldTags = oldText.match(/<[^>]*>[^<]*<\/[^>]*>|<[^>]*>/g);
    const newTags = newText.match(/<[^>]*>[^<]*<\/[^>]*>|<[^>]*>/g);

    const diffs = [];
    oldTags.forEach((oldTag, i) => {
      if (!newTags.includes(oldTag)) {
        diffs.push(
          `<span style="color: red;text-decoration:line-through">${oldTag}</span>`
        );
      } else if (newTags[i] !== oldTag) {
        diffs.push(
          `<span style="color: red;text-decoration:line-through">${oldTag}</span><span style="color: green">${newTags[i]}</span>`
        );
      } else {
        diffs.push(oldTag);
      }
    });

    newTags.forEach((newTag, i) => {
      if (
        !oldTags.includes(newTag) &&
        (i >= oldTags.length || newTags[i] !== oldTags[i])
      ) {
        diffs.push(`<span style="color: green">${newTag}</span>`);
      }
    });

    const diffsText = diffs.join("");
    setKeyFindingsChanges(diffsText);
    // console.log(diffsText);
  }

  const [activeVersion, setActiveVersion] = useState(null);
  const versionClickHandler = (versionId) => {
    if (activeVersion === versionId) {
      setActiveVersion(null);
      setKeyFindingsChanges(() => pageInfo?.key_findings);
      setTitleChanges(() => pageInfo?.title);
      setFileChanges(pageInfo?.files);
    } else {
      setActiveVersion(versionId);
      getVersion(versionId);
    }
  };

  const restoreVersion = (versionId) => {
    fetch({ Url }.Url + "/restore_page_version/" + pageSlug + "/", {
      method: "POST",
      body: JSON.stringify({
        version_id: versionId,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            window.location.reload();
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  // const { isSticky, element } = useSticky();

  const [summary, setSummary] = useState("");

  const getSummaryHandler = () => {
    setSummary(null);

    onOpen9();
    fetch({ Url }.Url + "/summarize/?type=page&id=" + pageSlug, {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            console.log(res.data);
            setSummary(res.data.summary);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  const generateSummaryHandler = () => {
    setSummary(null);

    fetch({ Url }.Url + "/summarize/?type=page&id=" + pageSlug, {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            console.log(res.data);
            setSummary(res.data.summary);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });

            // swal("Oops, something went wrong!", res.data.detail, "error");
          }
        })
    );
  };

  function changeShowVal(){
    if(switchVal===true)
    setSwitchVal(false)
  else setSwitchVal(true)

  console.log(switchVal);
  }

  return (
    <>
      <Flex
        flexDir="column"
        width="100%"
        pl={"2%"}
        pr={isOpen5 ? "270px" : "2%"}
        transition="all 0.3s ease"
      >
        <Flex
          alignItems="center"
          width={{ md: "100%" }}
          height="fit-content"
          flexDir="column"
          justifyContent="space-between"
          px="10px"
        >
          {pageInfo ? (
            <Flex
              ref={contentRef}
              width={["99%", "99%", "100%", "100%", "100%"]}
              flexDir="column"
              mr="10px"
            >
              <Flex
                flexDir={{ base: "column", md: "row" }}
                justifyContent={{ md: "space-between" }}
                alignItems={{ md: "center" }}
                borderBottom="2px solid  rgba(255, 255, 255, 0.24)"
                position={{ md: "fixed" }}
                style={{ zIndex: 10 }}
                pb={{ base: "1", md: "0" }}
                width={{ md: "95%" }}
                bg="background.dark"
                pr={isOpen5 ? "240px" : "0"}
                transition="all 0.3s ease"
              >
                <Flex flexDir={"column"}>
                  <Flex
                    w="100%"
                    color="white"
                    fontWeight="400"
                    alignItems="center"
                    justifyContent={"start"}
                    mt={2}
                  >
                    <Breadcrumbs breadcrumbs={breadcrumbs} />
                    <Flex
                      flexDir="row"
                      alignItems="center"
                      // _hover={{
                      //   borderBottom:pageInfo.approval_block_exists ? (pageInfo.approved === 'not approved' ? '2px solid #FF5858' : '2px solid #04CD00') : '2px solid #FFC949'

                      // }}
                    >
                      <Text
                        display="inline"
                        color={
                          pageInfo.approval_block_exists
                            ? pageInfo.approved === "not approved"
                              ? "#FF5858"
                              : "#04CD00"
                            : "#FFC949"
                        }
                        fontWeight="700"
                        fontSize={{ md: "20px" }}
                      >
                        {!isLargerThan1000 && pageInfo?.title.length > 13 ? (
                          pageInfo.title.slice(0, 13) + ".."
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: titleChanges
                                ? titleChanges
                                : pageInfo?.title,
                            }}
                          />
                        )}{" "}
                      </Text>
                      {isCollab && (
                        <Flex
                          cursor="pointer"
                          onClick={() => editPageSessionBegin()}
                          ml={1}
                        >
                          {pageInfo.approval_block_exists ? (
                            pageInfo.approved === "not approved" ? (
                              <svg
                                style={{ display: "inline" }}
                                width="18"
                                height="20"
                                viewBox="0 0 22 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.393 6.868C20.897 6.364 21.1743 5.69466 21.1743 4.98267C21.1743 4.27067 20.897 3.60133 20.393 3.09733L18.2783 0.982665C17.7743 0.478665 17.105 0.201332 16.393 0.201332C15.681 0.201332 15.0117 0.478665 14.509 0.981332L0.333008 15.1133V21H6.21701L20.393 6.868ZM16.393 2.868L18.509 4.98133L16.389 7.09333L14.2743 4.98L16.393 2.868ZM2.99967 18.3333V16.22L12.3863 6.86266L14.501 8.97733L5.11567 18.3333H2.99967ZM0.333008 23.6667H21.6663V26.3333H0.333008V23.6667Z"
                                  fill="#FF3D3D"
                                />
                              </svg>
                            ) : (
                              <svg
                                style={{ display: "inline" }}
                                width="18"
                                height="20"
                                viewBox="0 0 22 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.393 6.868C20.897 6.364 21.1743 5.69466 21.1743 4.98267C21.1743 4.27067 20.897 3.60133 20.393 3.09733L18.2783 0.982665C17.7743 0.478665 17.105 0.201332 16.393 0.201332C15.681 0.201332 15.0117 0.478665 14.509 0.981332L0.333008 15.1133V21H6.21701L20.393 6.868ZM16.393 2.868L18.509 4.98133L16.389 7.09333L14.2743 4.98L16.393 2.868ZM2.99967 18.3333V16.22L12.3863 6.86266L14.501 8.97733L5.11567 18.3333H2.99967ZM0.333008 23.6667H21.6663V26.3333H0.333008V23.6667Z"
                                  fill="#04CD00"
                                />
                              </svg>
                            )
                          ) : (
                            <svg
                              style={{ display: "inline" }}
                              width="18"
                              height="20"
                              viewBox="0 0 22 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.393 6.868C20.897 6.364 21.1743 5.69466 21.1743 4.98267C21.1743 4.27067 20.897 3.60133 20.393 3.09733L18.2783 0.982665C17.7743 0.478665 17.105 0.201332 16.393 0.201332C15.681 0.201332 15.0117 0.478665 14.509 0.981332L0.333008 15.1133V21H6.21701L20.393 6.868ZM16.393 2.868L18.509 4.98133L16.389 7.09333L14.2743 4.98L16.393 2.868ZM2.99967 18.3333V16.22L12.3863 6.86266L14.501 8.97733L5.11567 18.3333H2.99967ZM0.333008 23.6667H21.6663V26.3333H0.333008V23.6667Z"
                                fill="#FFC949"
                              />
                            </svg>
                          )}
                        </Flex>
                      )}
                    </Flex>
                  </Flex>
                  <Flex flexDir="column" my={1} py={1} bg="bg">
                    <Flex flexDir="row" alignItems="center" pb={1}>
                      <Avatar
                        size="xs"
                        bg="white"
                        name={pageInfo?.author}
                        src={pageInfo?.author}
                        color="#2D3842"
                        fontWeight="700"
                        mr={2}
                      />
                      <Text fontSize="14px" color="white">
                        {pageInfo?.author + " "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>{" "}
                        &nbsp; Last modified{" "}
                        {" " + pageInfo.last_modified?.split("T")[0]}{" "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>
                        &nbsp;{" "}
                        {pageInfo.last_modified
                          ?.split("T")[1]
                          .split(".")[0]
                          .slice(0, 5)}{" "}
                        <Text
                          borderRight="2px solid #FFFFFF3D"
                          display="inline"
                        >
                          &nbsp;
                        </Text>
                        &nbsp;
                        {pageInfo?.project?.role?.toUpperCase() + " "}
                      </Text>
                      <Text
                        borderLeft="2px solid #FFFFFF3D"
                        display="inline"
                        color="white"
                        ml="1"
                        onClick={() => {
                          getSummaryHandler();
                        }}
                        _hover={{ cursor: "pointer", color: "main.text" }}
                      >
                        &nbsp; Summarize
                        <svg
                          style={{
                            display: "inline",
                            transform: "translateY(2px)",
                          }}
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          height="16"
                          width="16"
                        >
                          <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 001.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 00-1.828 1.829l-.645 1.936a.361.361 0 01-.686 0l-.645-1.937a2.89 2.89 0 00-1.828-1.828l-1.937-.645a.361.361 0 010-.686l1.937-.645a2.89 2.89 0 001.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 01.412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 010 .412l-1.162.387A1.734 1.734 0 004.593 5.69l-.387 1.162a.217.217 0 01-.412 0L3.407 5.69A1.734 1.734 0 002.31 4.593l-1.162-.387a.217.217 0 010-.412l1.162-.387A1.734 1.734 0 003.407 2.31l.387-1.162zM10.863.099a.145.145 0 01.274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 010 .274l-.774.258a1.156 1.156 0 00-.732.732l-.258.774a.145.145 0 01-.274 0l-.258-.774a1.156 1.156 0 00-.732-.732L9.1 2.137a.145.145 0 010-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z" />
                        </svg>
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
                {authCtx.role !== "Client" && isCollab && (
                  <Flex
                    flexDir={"column"}
                    alignItems={"middle"}
                    justifyContent={"start"}
                  >
                    <Flex
                      flexDir="row"
                      alignItems="center"
                      justifyContent={"start"}
                      width="100%"
                    >
                      {!app ? (
                        <Button
                          bg="background.yellow1"
                          p={2}
                          color="white"
                          my={2}
                          mr={{ base: 1, md: 0 }}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          width={"100%"}
                          maxW="200px"
                          height="1.9rem"
                          onClick={onOpen}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                              fill="white"
                            />
                            <path
                              d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp; Add Approval Page
                        </Button>
                      ) : (
                        <Button
                          bg="background.yellow1"
                          p={1}
                          px={2}
                          color="white"
                          width={"max-content"}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          w="100%"
                          maxW="200px"
                          height="1.9rem"
                          onClick={() =>
                            (window.location = "/approval/" + pageSlug)
                          }
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                              fill="white"
                            />
                            <path
                              d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                              fill="white"
                            />
                          </svg>
                          &nbsp; Approval Page
                        </Button>
                      )}
                      {
                        <Button
                          bg="#444d54"
                          p={1}
                          px={2}
                          color="white"
                          ml={2}
                          my={2}
                          width={"max-content"}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          height="1.9rem"
                          onClick={() => {
                            onToggle5();
                            getVersions();
                          }}
                        >
                          <svg
                            width="48"
                            height="18"
                            viewBox="0 0 24 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 2C0 1.60218 0.158035 1.22064 0.43934 0.93934C0.720644 0.658035 1.10218 0.5 1.5 0.5H22.5C22.8978 0.5 23.2794 0.658035 23.5607 0.93934C23.842 1.22064 24 1.60218 24 2V5C24 5.39782 23.842 5.77936 23.5607 6.06066C23.2794 6.34196 22.8978 6.5 22.5 6.5V17.75C22.5 18.7446 22.1049 19.6984 21.4016 20.4016C20.6984 21.1049 19.7446 21.5 18.75 21.5H5.25C4.25544 21.5 3.30161 21.1049 2.59835 20.4016C1.89509 19.6984 1.5 18.7446 1.5 17.75V6.5C1.10218 6.5 0.720644 6.34196 0.43934 6.06066C0.158035 5.77936 0 5.39782 0 5V2ZM3 6.5V17.75C3 18.3467 3.23705 18.919 3.65901 19.341C4.08097 19.7629 4.65326 20 5.25 20H18.75C19.3467 20 19.919 19.7629 20.341 19.341C20.7629 18.919 21 18.3467 21 17.75V6.5H3ZM22.5 2H1.5V5H22.5V2ZM7.5 10.25C7.5 10.0511 7.57902 9.86032 7.71967 9.71967C7.86032 9.57902 8.05109 9.5 8.25 9.5H15.75C15.9489 9.5 16.1397 9.57902 16.2803 9.71967C16.421 9.86032 16.5 10.0511 16.5 10.25C16.5 10.4489 16.421 10.6397 16.2803 10.7803C16.1397 10.921 15.9489 11 15.75 11H8.25C8.05109 11 7.86032 10.921 7.71967 10.7803C7.57902 10.6397 7.5 10.4489 7.5 10.25Z"
                              fill="white"
                            />
                          </svg>
                        </Button>
                      }
                    </Flex>
                    <Flex justifyContent={"start"}>
                      {
                        <Button
                          bg="#444d54"
                          p={1}
                          px={2}
                          color="white"
                          mr={2}
                          width={"max-content"}
                          fontSize="13px"
                          // mr="10px"
                          as="a"
                          height="1.9rem"
                          onClick={() => {
                            onOpen4();
                            getComments();
                          }}
                        >
                          <svg
                            width="40"
                            height="21"
                            viewBox="0 0 22 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.68225 15.3218C3.82497 15.4683 3.93433 15.6453 4.00254 15.84C4.07076 16.0347 4.09614 16.2424 4.07687 16.4484C3.98024 17.4013 3.79703 18.343 3.52962 19.2612C5.44775 18.807 6.61925 18.2809 7.15138 18.0053C7.45319 17.8489 7.80077 17.8119 8.12763 17.9012C9.0646 18.1567 10.0303 18.2853 11 18.2838C16.4945 18.2838 20.625 14.3359 20.625 9.8451C20.625 5.35574 16.4945 1.40644 11 1.40644C5.5055 1.40644 1.375 5.35574 1.375 9.8451C1.375 11.9098 2.22338 13.8253 3.68225 15.3218ZM3.00437 20.814C2.67859 20.88 2.35176 20.9405 2.024 20.9954C1.749 21.0404 1.54 20.7478 1.64863 20.4862C1.77071 20.1917 1.88262 19.8929 1.98413 19.5903L1.98825 19.5763C2.32925 18.5636 2.607 17.3991 2.70875 16.3147C1.02162 14.5848 0 12.3204 0 9.8451C0 4.40779 4.92525 0 11 0C17.0748 0 22 4.40779 22 9.8451C22 15.2824 17.0748 19.6902 11 19.6902C9.91052 19.6917 8.82556 19.547 7.77287 19.2598C7.05788 19.6297 5.51925 20.3034 3.00437 20.814Z"
                              fill="white"
                            />
                            {!pageInfo?.comment_view_status && (
                              <circle cx="20" cy="3" r="4" fill="#FF3D3D" />
                            )}
                          </svg>
                        </Button>
                      }
                      <Menu width={"100%"}>
                        <MenuButton width={"100%"} maxW="200px">
                          <Button
                            bg="#444d54"
                            justifyContent={"left"}
                            py={1}
                            width="100%"
                            px={2}
                            color="white"
                            height="1.9rem"
                            fontSize="13px"
                            _hover={{
                              background: "#F2DBA6",
                            }}
                            // mr="10px"
                          >
                            <svg
                              width="22"
                              height="20"
                              viewBox="0 0 22 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.8187 14.2469C18.8226 13.6703 17.6085 13.825 16.7906 14.5469L15.5484 13.8273V10.2719C15.5484 9.90391 15.3515 9.56172 15.0328 9.37891L11.8453 7.54375V5.97109C12.8812 5.61953 13.6265 4.63984 13.6265 3.48438C13.6265 2.03359 12.4523 0.859375 11.0015 0.859375C9.55073 0.859375 8.37651 2.03359 8.37651 3.48438C8.37651 4.63984 9.12183 5.61953 10.1578 5.97109V7.54375L6.97026 9.37891C6.65151 9.56172 6.45464 9.90391 6.45464 10.2719V13.825L5.21245 14.5445C4.39448 13.8227 3.17808 13.668 2.18433 14.2445C0.93042 14.9711 0.503858 16.5742 1.22339 17.8281C1.94526 19.082 3.54136 19.5133 4.79058 18.7891C5.78667 18.2125 6.26011 17.0781 6.04683 16.0047L7.18823 15.3414L10.4835 17.2398C10.6429 17.3313 10.821 17.3781 10.9992 17.3781C11.1773 17.3781 11.3554 17.3313 11.5148 17.2398L14.8078 15.3438L15.9492 16.007C15.7359 17.0781 16.2117 18.2148 17.2054 18.7914C18.4546 19.5156 20.0531 19.0867 20.7726 17.8305C21.4945 16.5742 21.0679 14.9711 19.8187 14.2469ZM4.04526 17.4906C3.91796 17.5644 3.77733 17.6122 3.63148 17.6313C3.48562 17.6505 3.33741 17.6406 3.19538 17.6023C3.05335 17.564 2.92031 17.4979 2.80391 17.408C2.68751 17.318 2.59005 17.2059 2.51714 17.0781C2.20776 16.5414 2.39058 15.8523 2.9273 15.543C3.0546 15.4692 3.19522 15.4214 3.34108 15.4022C3.48694 15.3831 3.63515 15.3929 3.77718 15.4313C3.91921 15.4696 4.05225 15.5357 4.16865 15.6256C4.28505 15.7156 4.38251 15.8277 4.45542 15.9555C4.7648 16.4922 4.58198 17.1812 4.04526 17.4906ZM9.87417 3.48438C9.88018 3.18998 10.0013 2.90968 10.2117 2.7036C10.422 2.49753 10.7047 2.38211 10.9992 2.38211C11.2936 2.38211 11.5763 2.49753 11.7867 2.7036C11.997 2.90968 12.1182 3.18998 12.1242 3.48438C12.1182 3.77877 11.997 4.05907 11.7867 4.26515C11.5763 4.47122 11.2936 4.58664 10.9992 4.58664C10.7047 4.58664 10.422 4.47122 10.2117 4.26515C10.0013 4.05907 9.88018 3.77877 9.87417 3.48438ZM13.8585 13.9422L10.9992 15.5898L8.1398 13.9422V10.6516L10.9992 9.00391L13.8585 10.6516V13.9422ZM19.4812 17.0805C19.1718 17.6172 18.4875 17.8023 17.9531 17.493C17.4187 17.1836 17.2335 16.4945 17.5429 15.9578C17.8523 15.4211 18.5367 15.2359 19.071 15.5453C19.6078 15.8547 19.7906 16.5414 19.4812 17.0805Z"
                                fill="white"
                              />
                            </svg>
                            &nbsp; More Actions
                          </Button>
                        </MenuButton>

                        <MenuList>
                          <MenuItem onClick={onOpen2}>Copy Block</MenuItem>
                          <MenuItem onClick={onOpen3}>
                            Delete this block
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </Flex>
                  </Flex>
                )}
              </Flex>

              <Flex
                flexDir={{ base: "column", md: "row" }}
                alignItems="flex-start"
                justifyContent="space-between"
                mt="85px"
              >
            
                <Flex
                  flexDir="column"
                  width={{ base: "100%", md: "fill-available" }}
                  mr={{ base: "0px", md: "30px" }}
                >
                {/* {collapseVal==="both"?<><Flex mt={"20vh"} color={"main.plainWhite"} alignItems={"center"} justifyContent="center">Nothing is here</Flex></>:null} */}
                  <Flex justifyContent="space-between">
                    <Flex>
                      <Text
                        color="white"
                        mt="20px"
                        fontSize="18px"
                        lineHeight="1.3"
                        textTransform="uppercase"
                        fontWeight="700"
                        p={1}
                      >
                        {/* {collapseVal==="both"?null:<>Key FIndings</>}
                         */}
                         Key Findings
                      </Text>
                    </Flex>
                    <Flex>
                      
                    </Flex>
                  </Flex>
                   
                    <Text
                    color="black"
                    py={8}
                    px={8}
                    my={3}
                    minH="300px"
                    borderRadius="10px"
                    fontSize="18px"
                    background="white"
                    lineHeight="1.3"
                  >
                    {pageInfo.keyFindings !== "" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            keyFindingsChanges === ""
                              ? pageInfo.keyFindings
                              : keyFindingsChanges,
                        }}
                      />
                    ) : (
                      <div>No key findings found!</div>
                    )}
                  </Text>
                  {/* Spreadsheet commit */}
                  {/* <div
                    style={{ width: "82.5vw", height: "70vh", borderRadius:"10px", marginTop:'10px'}}
                    className="sheet-editor1"
                  >
                    {collapseVal==="document" || collapseVal==="none"? (
                      <>
                        <Workbook data={sheetData} isDisabled freeze />
                      </>
                    ) : null}
                  </div> */}
                </Flex>
                
                <Flex
                  flexDir="column"
                  maxWidth={{
                    base: "100%",
                    md: fileChanges?.length <= 3 ? "150px" : "300px",
                  }}
                >
                  <Text
                    color="white"
                    mt="20px"
                    fontSize="18px"
                    lineHeight="1.3"
                    textTransform="uppercase"
                    fontWeight="700"
                    py={1}
                  >
                    Files
                  </Text>
                  <Flex
                    flexDir="column"
                    overflowY={"auto"}
                    pr={1}
                    maxH={{ lg: "450px" }}
                    maxWidth={{
                      base: "100%",
                      md: fileChanges?.length > 3 ? "300px" : "150px",
                    }}
                    minWidth={{
                      base: "100%",
                      md: fileChanges?.length > 3 ? "200px" : "100px",
                    }}
                  >
                    {fileChanges?.length <= 3 &&
                      fileChanges.map((file, id) => (
                        <>
                          <Flex
                            cursor={"pointer"}
                            onClick={() =>
                              window.open(
                                file.file,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                            cur
                            target="_blank"
                            color="white"
                            p={2}
                            my={1}
                            background="grey3"
                            border={`2px solid ${
                              file?.version === "new"
                                ? "green"
                                : file?.version === "old"
                                ? "red"
                                : "none"
                            }`}
                            borderRadius="3px"
                          >
                            <Flex flexDir="column" height="100%" maxW={"100%"}>
                              <Flex flexDir={"column"} m={1} maxW={"100%"}>
                                <Text
                                  color="white"
                                  fontSize="13px"
                                  lineHeight="1.2"
                                  fontWeight="700"
                                  maxW="100%"
                                >
                                  {file?.title}
                                </Text>
                                <Tooltip
                                  hasArrow
                                  bg="#444d54"
                                  color="white"
                                  placement="bottom"
                                  label={file?.title}
                                >
                                  <Flex maxHeight="170px" py={3}>
                                    {file?.thumbnail ? (
                                      <img
                                        src={file.thumbnail}
                                        alt={"thumbnail"}
                                        style={{
                                          objectFit: "contain",
                                          minWidth: "80px",
                                        }}
                                      />
                                    ) : (
                                      <>
                                        {(file.file.includes("sheet") ||
                                          file.file.includes("csv") ||
                                          file.file.includes("xls")) &&
                                          !file.file.includes(".zip") && (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 48 48"
                                              width="48"
                                              height="48"
                                            >
                                              <linearGradient
                                                id="PTsiEfj2THKtO9xz06mlla"
                                                x1="24"
                                                x2="24"
                                                y1="5"
                                                y2="43"
                                                gradientUnits="userSpaceOnUse"
                                              >
                                                <stop
                                                  offset="0"
                                                  stopColor="#21ad64"
                                                />
                                                <stop
                                                  offset="1"
                                                  stopColor="#088242"
                                                />
                                              </linearGradient>
                                              <path
                                                fill="url(#PTsiEfj2THKtO9xz06mlla)"
                                                d="M39,16v25c0,1.105-0.895,2-2,2H11c-1.105,0-2-0.895-2-2V7c0-1.105,0.895-2,2-2h17L39,16z"
                                              />
                                              <path
                                                fill="#61e3a7"
                                                d="M28,5v9c0,1.105,0.895,2,2,2h9L28,5z"
                                              />
                                              <path
                                                fill="#107c42"
                                                d="M39,16h-9c-0.473,0-0.917-0.168-1.257-0.444L39,27V16z"
                                              />
                                              <path
                                                fill="#fff"
                                                d="M32,23H16c-0.553,0-1,0.448-1,1v12c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V24 C33,23.448,32.553,23,32,23z M17,29h4v2h-4V29z M23,29h8v2h-8V29z M31,27h-8v-2h8V27z M21,25v2h-4v-2H21z M17,33h4v2h-4V33z M23,35 v-2h8v2H23z"
                                              />
                                              <path
                                                d="M32,22.5c0.827,0,1.5,0.673,1.5,1.5v12c0,0.827-0.673,1.5-1.5,1.5H16c-0.827,0-1.5-0.673-1.5-1.5V24 c0-0.827,0.673-1.5,1.5-1.5H32 M32,22H16c-1.103,0-2,0.897-2,2v12c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V24 C34,22.897,33.103,22,32,22L32,22z"
                                                opacity=".05"
                                              />
                                              <path
                                                d="M32,23c0.553,0,1,0.448,1,1v12c0,0.552-0.447,1-1,1H16c-0.553,0-1-0.448-1-1V24c0-0.552,0.447-1,1-1 H32 M32,22.5H16c-0.827,0-1.5,0.673-1.5,1.5v12c0,0.827,0.673,1.5,1.5,1.5h16c0.827,0,1.5-0.673,1.5-1.5V24 C33.5,23.173,32.827,22.5,32,22.5L32,22.5z"
                                                opacity=".07"
                                              />
                                            </svg>
                                          )}
                                        {file.file.includes("document") && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 48 48"
                                            width="48"
                                            height="48"
                                          >
                                            <path
                                              fill="#2196f3"
                                              d="M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
                                            />
                                            <path
                                              fill="#bbdefb"
                                              d="M40 13L30 13 30 3z"
                                            />
                                            <path
                                              fill="#1565c0"
                                              d="M30 13L40 23 40 13z"
                                            />
                                            <path
                                              fill="#e3f2fd"
                                              d="M15 23H33V25H15zM15 27H33V29H15zM15 31H33V33H15zM15 35H25V37H15z"
                                            />
                                          </svg>
                                        )}
                                        {file.file
                                          .toLowerCase()
                                          .includes("sheet") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("document") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("drive") === false &&
                                          file.file.includes("colab") ===
                                            false &&
                                          file.file
                                            .toLowerCase()
                                            .includes(".r") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("ipynb") === false &&
                                          !file.file
                                            .toLowerCase()
                                            .includes(".py") &&
                                          !file.file
                                            .toLowerCase()
                                            .includes("kms") &&
                                          !file.file.includes(".zip") &&
                                          file.file.includes("http") && (
                                            <Text>
                                              <svg
                                                viewBox="0 0 21 21"
                                                fill="currentColor"
                                                height="48"
                                                width="48"
                                              >
                                                <g
                                                  fill="none"
                                                  fillRule="evenodd"
                                                  stroke="currentColor"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <path d="M9.5 11.5c.97 1.367 3.011 1.127 4.011 0l1.989-2c1.124-1.228 1.164-2.814 0-4-1.136-1.157-2.864-1.157-4 0l-2 2" />
                                                  <path d="M11.5 10.57c-.97-1.367-3-1.197-4-.07l-2 1.975c-1.124 1.228-1.164 2.839 0 4.025 1.136 1.157 2.864 1.157 4 0l2-2" />
                                                </g>
                                              </svg>
                                            </Text>
                                          )}
                                        {file.file
                                          .toLowerCase()
                                          .includes("sheet") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("document") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("drive") === false &&
                                          file.file.includes("colab") ===
                                            false &&
                                          file.file
                                            .toLowerCase()
                                            .includes(".r") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("ipynb") === false &&
                                          !file.file
                                            .toLowerCase()
                                            .includes(".py") &&
                                          !file.file
                                            .toLowerCase()
                                            .includes("kms") &&
                                          !file.file.includes("http") &&
                                          !file.file.includes(".zip") && (
                                            <Text>
                                              <svg
                                                viewBox="0 0 1024 1024"
                                                fill="currentColor"
                                                height="48"
                                                width="48"
                                              >
                                                <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" />
                                              </svg>
                                            </Text>
                                          )}
                                        {(file.file.includes("colab") ||
                                          file.file.includes(".py") ||
                                          file.file.includes("ipynb") ||
                                          file.file
                                            .toLowerCase()
                                            .includes(".r")) &&
                                          !file.file.includes(".zip") && (
                                            <Text>
                                              <svg
                                                viewBox="0 0 16 16"
                                                fill="currentColor"
                                                height="48"
                                                width="48"
                                              >
                                                <path d="M9.293 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.707A1 1 0 0013.707 4L10 .293A1 1 0 009.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 01-1-1zM6.646 7.646a.5.5 0 11.708.708L5.707 10l1.647 1.646a.5.5 0 01-.708.708l-2-2a.5.5 0 010-.708l2-2zm2.708 0l2 2a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708L10.293 10 8.646 8.354a.5.5 0 11.708-.708z" />
                                              </svg>
                                            </Text>
                                          )}
                                        {file.file.includes(".zip") && (
                                          <Text>
                                            <svg
                                              viewBox="0 0 1024 1024"
                                              fill="currentColor"
                                              height="48"
                                              width="48"
                                            >
                                              <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" />
                                            </svg>
                                          </Text>
                                        )}
                                        {file.file
                                          .toLowerCase()
                                          .includes("sheet") === false &&
                                          !file.file.includes("csv") &&
                                          !file.file.includes("xls") &&
                                          file.file
                                            .toLowerCase()
                                            .includes("document") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("drive") === false &&
                                          file.file.includes("colab") ===
                                            false &&
                                          file.file
                                            .toLowerCase()
                                            .includes(".r") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("ipynb") === false &&
                                          file.file
                                            .toLowerCase()
                                            .includes("kms") &&
                                          !file.file.includes(".zip") && (
                                            <Text>
                                              <svg
                                                width="48"
                                                height="48"
                                                viewBox="0 0 39 39"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  width="39"
                                                  height="39"
                                                  rx="19.5"
                                                  fill="#2D3842"
                                                />
                                                <path
                                                  d="M19.5683 8.37869L23.941 17.8038L8.5946 30.7297L19.5683 8.37869Z"
                                                  fill="#BC9842"
                                                />
                                                <path
                                                  d="M19.4711 8.35135L15.0984 17.7765L30.4448 30.7024L19.4711 8.35135Z"
                                                  fill="#BC9842"
                                                />
                                              </svg>
                                            </Text>
                                          )}{" "}
                                        {file.file.includes("sheet") ===
                                          false &&
                                          file.file.includes("document") ===
                                            false &&
                                          file.file.includes("drive") && (
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 48 48"
                                              width="48"
                                              height="48"
                                            >
                                              <path
                                                fill="#FFC107"
                                                d="M17 6L31 6 45 30 31 30z"
                                              />
                                              <path
                                                fill="#1976D2"
                                                d="M9.875 42L16.938 30 45 30 38 42z"
                                              />
                                              <path
                                                fill="#4CAF50"
                                                d="M3 30.125L9.875 42 24 18 17 6z"
                                              />
                                            </svg>
                                          )}
                                      </>
                                    )}
                                  </Flex>
                                </Tooltip>
                                <Text color="#ACACAC" fontSize="12px">
                                  {file.description}
                                </Text>
                              </Flex>
                            </Flex>
                            {/* <Flex cursor="pointer" transition={'all 0.2s ease'}>
                              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.25 0.75L17.3662 4.86625L8.61621 13.6163L10.3837 15.3837L19.1337 6.63375L23.25 10.75V0.75H13.25Z" fill="white" />
                                <path
                                  d="M20.75 20.75H3.25V3.25H12L9.5 0.75H3.25C1.87125 0.75 0.75 1.87125 0.75 3.25V20.75C0.75 22.1287 1.87125 23.25 3.25 23.25H20.75C22.1287 23.25 23.25 22.1287 23.25 20.75V14.5L20.75 12V20.75Z"
                                  fill="white"
                                />
                              </svg>
                            </Flex> */}
                          </Flex>
                        </>
                      ))}
                    <Box
                      display="grid"
                      gridTemplateColumns="repeat(2, 1fr)"
                      gridGap={1}
                    >
                      {fileChanges?.length >= 4 &&
                        fileChanges.map((file, id) => (
                          <>
                            <Flex
                              cursor={"pointer"}
                              onClick={() =>
                                window.open(
                                  file.file,
                                  "_blank",
                                  "noopener,noreferrer"
                                )
                              }
                              cur
                              target="_blank"
                              direction="row"
                              alignItems="start"
                              color="white"
                              p={2}
                              background="grey0"
                              borderRadius="7px"
                              maxW="170px"
                            >
                              <Flex
                                flexDir="column"
                                height="100%"
                                style={{ maxWidth: "100%" }}
                              >
                                <Flex
                                  flexDir={"column"}
                                  mt={1}
                                  height={"100%"}
                                  justifyContent="space-between"
                                >
                                  <Text
                                    color="white"
                                    fontSize="13px"
                                    lineHeight="1.2"
                                    fontWeight="700"
                                  >
                                    {file.title?.length > 15
                                      ? file.title?.slice(0, 15) + ".."
                                      : file.title}
                                  </Text>
                                  <Box
                                    flex="1"
                                    position="relative"
                                    d="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    x
                                  >
                                    <Tooltip
                                      hasArrow
                                      bg="#444d54"
                                      color="white"
                                      placement="bottom"
                                      label={file?.title}
                                    >
                                      <Flex py={3} mb={4}>
                                        {file?.thumbnail ? (
                                          <img
                                            src={file.thumbnail}
                                            alt={"thumbnail"}
                                            style={{
                                              objectFit: "contain",
                                              minWidth: "80px",
                                              maxWidth: "120px",
                                            }}
                                          />
                                        ) : (
                                          <>
                                            {(file.file.includes("sheet") ||
                                              file.file.includes("csv") ||
                                              file.file.includes("xls")) &&
                                              !file.file.includes(".zip") && (
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 48 48"
                                                  width="48"
                                                  height="48"
                                                >
                                                  <linearGradient
                                                    id="PTsiEfj2THKtO9xz06mlla"
                                                    x1="24"
                                                    x2="24"
                                                    y1="5"
                                                    y2="43"
                                                    gradientUnits="userSpaceOnUse"
                                                  >
                                                    <stop
                                                      offset="0"
                                                      stopColor="#21ad64"
                                                    />
                                                    <stop
                                                      offset="1"
                                                      stopColor="#088242"
                                                    />
                                                  </linearGradient>
                                                  <path
                                                    fill="url(#PTsiEfj2THKtO9xz06mlla)"
                                                    d="M39,16v25c0,1.105-0.895,2-2,2H11c-1.105,0-2-0.895-2-2V7c0-1.105,0.895-2,2-2h17L39,16z"
                                                  />
                                                  <path
                                                    fill="#61e3a7"
                                                    d="M28,5v9c0,1.105,0.895,2,2,2h9L28,5z"
                                                  />
                                                  <path
                                                    fill="#107c42"
                                                    d="M39,16h-9c-0.473,0-0.917-0.168-1.257-0.444L39,27V16z"
                                                  />
                                                  <path
                                                    fill="#fff"
                                                    d="M32,23H16c-0.553,0-1,0.448-1,1v12c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V24 C33,23.448,32.553,23,32,23z M17,29h4v2h-4V29z M23,29h8v2h-8V29z M31,27h-8v-2h8V27z M21,25v2h-4v-2H21z M17,33h4v2h-4V33z M23,35 v-2h8v2H23z"
                                                  />
                                                  <path
                                                    d="M32,22.5c0.827,0,1.5,0.673,1.5,1.5v12c0,0.827-0.673,1.5-1.5,1.5H16c-0.827,0-1.5-0.673-1.5-1.5V24 c0-0.827,0.673-1.5,1.5-1.5H32 M32,22H16c-1.103,0-2,0.897-2,2v12c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V24 C34,22.897,33.103,22,32,22L32,22z"
                                                    opacity=".05"
                                                  />
                                                  <path
                                                    d="M32,23c0.553,0,1,0.448,1,1v12c0,0.552-0.447,1-1,1H16c-0.553,0-1-0.448-1-1V24c0-0.552,0.447-1,1-1 H32 M32,22.5H16c-0.827,0-1.5,0.673-1.5,1.5v12c0,0.827,0.673,1.5,1.5,1.5h16c0.827,0,1.5-0.673,1.5-1.5V24 C33.5,23.173,32.827,22.5,32,22.5L32,22.5z"
                                                    opacity=".07"
                                                  />
                                                </svg>
                                              )}
                                            {file.file.includes("document") && (
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 48 48"
                                                width="48"
                                                height="48"
                                              >
                                                <path
                                                  fill="#2196f3"
                                                  d="M37,45H11c-1.657,0-3-1.343-3-3V6c0-1.657,1.343-3,3-3h19l10,10v29C40,43.657,38.657,45,37,45z"
                                                />
                                                <path
                                                  fill="#bbdefb"
                                                  d="M40 13L30 13 30 3z"
                                                />
                                                <path
                                                  fill="#1565c0"
                                                  d="M30 13L40 23 40 13z"
                                                />
                                                <path
                                                  fill="#e3f2fd"
                                                  d="M15 23H33V25H15zM15 27H33V29H15zM15 31H33V33H15zM15 35H25V37H15z"
                                                />
                                              </svg>
                                            )}
                                            {file.file
                                              .toLowerCase()
                                              .includes("sheet") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("document") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("drive") === false &&
                                              file.file.includes("colab") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes(".r") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("ipynb") === false &&
                                              !file.file
                                                .toLowerCase()
                                                .includes(".py") &&
                                              !file.file
                                                .toLowerCase()
                                                .includes("kms") &&
                                              !file.file.includes(".zip") &&
                                              file.file.includes("http") && (
                                                <Text>
                                                  <svg
                                                    viewBox="0 0 21 21"
                                                    fill="currentColor"
                                                    height="48"
                                                    width="48"
                                                  >
                                                    <g
                                                      fill="none"
                                                      fillRule="evenodd"
                                                      stroke="currentColor"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    >
                                                      <path d="M9.5 11.5c.97 1.367 3.011 1.127 4.011 0l1.989-2c1.124-1.228 1.164-2.814 0-4-1.136-1.157-2.864-1.157-4 0l-2 2" />
                                                      <path d="M11.5 10.57c-.97-1.367-3-1.197-4-.07l-2 1.975c-1.124 1.228-1.164 2.839 0 4.025 1.136 1.157 2.864 1.157 4 0l2-2" />
                                                    </g>
                                                  </svg>
                                                </Text>
                                              )}
                                            {file.file
                                              .toLowerCase()
                                              .includes("sheet") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("document") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("drive") === false &&
                                              file.file.includes("colab") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes(".r") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("ipynb") === false &&
                                              !file.file
                                                .toLowerCase()
                                                .includes(".py") &&
                                              !file.file
                                                .toLowerCase()
                                                .includes("kms") &&
                                              !file.file.includes("http") &&
                                              !file.file.includes(".zip") && (
                                                <Text>
                                                  <svg
                                                    viewBox="0 0 1024 1024"
                                                    fill="currentColor"
                                                    height="48"
                                                    width="48"
                                                  >
                                                    <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 00-8 8v48a8 8 0 008 8h384a8 8 0 008-8v-48a8 8 0 00-8-8H320zm0 136a8 8 0 00-8 8v48a8 8 0 008 8h184a8 8 0 008-8v-48a8 8 0 00-8-8H320z" />
                                                  </svg>
                                                </Text>
                                              )}
                                            {(file.file.includes("colab") ||
                                              file.file.includes(".py") ||
                                              file.file.includes("ipynb") ||
                                              file.file
                                                .toLowerCase()
                                                .includes(".r")) &&
                                              !file.file.includes(".zip") && (
                                                <Text>
                                                  <svg
                                                    viewBox="0 0 16 16"
                                                    fill="currentColor"
                                                    height="48"
                                                    width="48"
                                                  >
                                                    <path d="M9.293 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.707A1 1 0 0013.707 4L10 .293A1 1 0 009.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 01-1-1zM6.646 7.646a.5.5 0 11.708.708L5.707 10l1.647 1.646a.5.5 0 01-.708.708l-2-2a.5.5 0 010-.708l2-2zm2.708 0l2 2a.5.5 0 010 .708l-2 2a.5.5 0 01-.708-.708L10.293 10 8.646 8.354a.5.5 0 11.708-.708z" />
                                                  </svg>
                                                </Text>
                                              )}
                                            {file.file.includes(".zip") && (
                                              <Text>
                                                <svg
                                                  viewBox="0 0 1024 1024"
                                                  fill="currentColor"
                                                  height="48"
                                                  width="48"
                                                >
                                                  <path d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z" />
                                                </svg>
                                              </Text>
                                            )}
                                            {file.file
                                              .toLowerCase()
                                              .includes("sheet") === false &&
                                              !file.file.includes("csv") &&
                                              !file.file.includes("xls") &&
                                              file.file
                                                .toLowerCase()
                                                .includes("document") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("drive") === false &&
                                              file.file.includes("colab") ===
                                                false &&
                                              file.file
                                                .toLowerCase()
                                                .includes(".r") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("ipynb") === false &&
                                              file.file
                                                .toLowerCase()
                                                .includes("kms") &&
                                              !file.file.includes(".zip") && (
                                                <Text>
                                                  <svg
                                                    width="48"
                                                    height="48"
                                                    viewBox="0 0 39 39"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <rect
                                                      width="39"
                                                      height="39"
                                                      rx="19.5"
                                                      fill="#2D3842"
                                                    />
                                                    <path
                                                      d="M19.5683 8.37869L23.941 17.8038L8.5946 30.7297L19.5683 8.37869Z"
                                                      fill="#BC9842"
                                                    />
                                                    <path
                                                      d="M19.4711 8.35135L15.0984 17.7765L30.4448 30.7024L19.4711 8.35135Z"
                                                      fill="#BC9842"
                                                    />
                                                  </svg>
                                                </Text>
                                              )}{" "}
                                            {file.file.includes("sheet") ===
                                              false &&
                                              file.file.includes("document") ===
                                                false &&
                                              file.file.includes("drive") && (
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 48 48"
                                                  width="48"
                                                  height="48"
                                                >
                                                  <path
                                                    fill="#FFC107"
                                                    d="M17 6L31 6 45 30 31 30z"
                                                  />
                                                  <path
                                                    fill="#1976D2"
                                                    d="M9.875 42L16.938 30 45 30 38 42z"
                                                  />
                                                  <path
                                                    fill="#4CAF50"
                                                    d="M3 30.125L9.875 42 24 18 17 6z"
                                                  />
                                                </svg>
                                              )}
                                          </>
                                        )}
                                      </Flex>
                                    </Tooltip>
                                    <Text color="#ACACAC" fontSize="12px">
                                      {file.description}
                                    </Text>
                                  </Box>
                                </Flex>
                              </Flex>
                              {/* <Flex cursor="pointer" transition={'all 0.2s ease'}>
                              <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.25 0.75L17.3662 4.86625L8.61621 13.6163L10.3837 15.3837L19.1337 6.63375L23.25 10.75V0.75H13.25Z" fill="white" />
                                <path
                                  d="M20.75 20.75H3.25V3.25H12L9.5 0.75H3.25C1.87125 0.75 0.75 1.87125 0.75 3.25V20.75C0.75 22.1287 1.87125 23.25 3.25 23.25H20.75C22.1287 23.25 23.25 22.1287 23.25 20.75V14.5L20.75 12V20.75Z"
                                  fill="white"
                                />
                              </svg>
                            </Flex> */}
                            </Flex>
                          </>
                        ))}
                    </Box>
                    {fileChanges.length === 0 && (
                      <Text color="main.grey1" fontSize="18px" fontWeight="700">
                        No Files Added
                      </Text>
                    )}
                  </Flex>
                  {isCollab ? (
                    <Text
                      pt={1}
                      color="main.text"
                      cursor="pointer"
                      fontWeight="700"
                    >
                      &gt;
                      <Text
                        display="inline"
                        onClick={() => onOpen7()}
                        _hover={{
                          textDecoration: "underline",
                        }}
                      >
                        Upload new
                      </Text>{" "}
                      <Text display="inline">or</Text>{" "}
                      <Text
                        display="inline"
                        onClick={() => onOpen8()}
                        _hover={{
                          textDecoration: "underline",
                        }}
                      >
                        Add a link
                      </Text>
                    </Text>
                  ) : null}
                  <Flex>
                    {d1 && d2 && (
                      <>
                        <Flex
                          flexDir="column"
                          height="100%"
                          // minW="360px"
                          minW="fit-content"
                        >
                          {hasChanged ? (
                            <>
                              <Text
                                color="white"
                                fontSize="21px"
                                mt="50px"
                                fontWeight="700"
                                textTransform={"uppercase"}
                              >
                                Parent blocks
                              </Text>
                              {d1.map((page, key) => (
                                <Flex
                                  flexDir="ROW"
                                  color="#D0D0D0"
                                  // width="400px"
                                  py="3px"
                                  borderRadius="10px"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Text
                                    color="#D0D0D0"
                                    fontSize="16px"
                                    lineHeight="1.3"
                                    fontWeight="700"
                                    cursor="pointer"
                                    onClick={() =>
                                      (window.location = "/page/" + page.id)
                                    }
                                    _hover={{
                                      textDecoration: "underline",
                                    }}
                                  >
                                    &gt;{page.title}
                                  </Text>
                                  {isCollab ? (
                                    <Icon
                                      as={BiTrash}
                                      mx="20px"
                                      height="20px"
                                      width="20px"
                                      cursor="pointer"
                                      onClick={() =>
                                        handleRemoveItem(1, key, page.id)
                                      }
                                    />
                                  ) : null}
                                </Flex>
                              ))}
                            </>
                          ) : null}
                          {isCollab ? (
                            <Text
                              color="main.text"
                              cursor="pointer"
                              fontWeight="700"
                              onClick={() =>
                                (window.location =
                                  "/link-child/" +
                                  pageInfo.project.id +
                                  "/" +
                                  pageSlug)
                              }
                            >
                              &gt;
                              <Text
                                display="inline"
                                _hover={{
                                  textDecoration: "underline",
                                }}
                              >
                                Link more
                              </Text>
                            </Text>
                          ) : null}

                          {hasChanged ? (
                            <>
                              <Text
                                color="white"
                                fontSize="21px"
                                mt="50px"
                                fontWeight="700"
                                textTransform={"uppercase"}
                              >
                                Child blocks
                              </Text>
                              {d2.map((page, key) => (
                                <Flex
                                  flexDir="ROW"
                                  color="#D0D0D0"
                                  // width="400px"
                                  py="3px"
                                  borderRadius="10px"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Text
                                    color="#D0D0D0"
                                    fontSize="14px"
                                    lineHeight="1.3"
                                    fontWeight="700"
                                    cursor="pointer"
                                    onClick={() =>
                                      (window.location = "/page/" + page.id)
                                    }
                                    _hover={{
                                      textDecoration: "underline",
                                    }}
                                  >
                                    &gt;{page.title}
                                  </Text>
                                  {isCollab ? (
                                    <Icon
                                      as={BiTrash}
                                      mx="20px"
                                      height="20px"
                                      width="20px"
                                      cursor="pointer"
                                      onClick={() =>
                                        handleRemoveItem(2, key, page.id)
                                      }
                                    />
                                  ) : null}
                                </Flex>
                              ))}
                            </>
                          ) : null}
                          {isCollab ? (
                            <Text
                              color="main.text"
                              cursor="pointer"
                              fontWeight="700"
                              onClick={() =>
                                (window.location =
                                  "/link-parent/" +
                                  pageInfo.project.id +
                                  "/" +
                                  pageSlug)
                              }
                            >
                              &gt;
                              <Text
                                display="inline"
                                _hover={{
                                  textDecoration: "underline",
                                }}
                              >
                                Link more
                              </Text>
                            </Text>
                          ) : null}
                        </Flex>
                      </>
                    )}
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          ) : (
            <Spinner color="white" />
          )}
        </Flex>
      </Flex>

      <>
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent bg="background.grey3" color="white">
            <ModalHeader>Add Approver</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Select placeholder="Select email" ref={emailA}>
                {dropdown
                  ? dropdown.map((d, id) => <option value={d}>{d}</option>)
                  : null}
              </Select>
            </ModalBody>

            <ModalFooter>
              <Button
                bg="background.yellow1"
                mr={3}
                onClick={createApprovalPage}
              >
                Submit
              </Button>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <>
          <Modal bg="#444d54" isOpen={isOpen3} onClose={onClose3} isCentered>
            <ModalOverlay BG="#0000004D" />
            <ModalContent bg="#444d54">
              <ModalHeader color="white">Delete this block</ModalHeader>
              <ModalBody>
                <Flex flexDir="column" mb="10px">
                  <Text color="white">
                    Blocks are deleted forever after 7 days.
                  </Text>
                  <Checkbox
                    defaultUnChecked
                    ref={subTreeBool2}
                    color="white"
                    fontSize="16px"
                    m="5px"
                    mt="15px"
                  >
                    Delete entire Subtree?
                  </Checkbox>
                </Flex>
              </ModalBody>

              <ModalFooter mt="10px">
                <Button
                  bg="#4B555E"
                  color="white"
                  fontSize="14px"
                  mr="10px"
                  onClick={deleteHandler}
                >
                  Delete Now
                </Button>
                <Button color="white" variant="ghost" onClick={onClose3}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
        <Modal bg="#444d54" isOpen={isOpen2} onClose={onClose2} isCentered>
          <ModalOverlay BG="#2A3843" />
          <ModalContent bg="#444d54">
            <ModalHeader color="white">Copy to an existing project</ModalHeader>
            <ModalBody>
              <Flex flexDir="column" mb="10px">
                <Select
                  color="white"
                  fontSize="16px"
                  mb="5px"
                  mt="15px"
                  placeholder="Select a project"
                  ref={projectA}
                >
                  {projectTitles
                    ? projectTitles.map((d, id) => (
                        <option value={d.id}>{d.title}</option>
                      ))
                    : null}
                </Select>
                <Checkbox
                  defaultUnChecked
                  ref={subTreeBool}
                  color="white"
                  fontSize="16px"
                  m="5px"
                  mt="15px"
                >
                  Copy entire Subtree
                </Checkbox>
              </Flex>
            </ModalBody>

            <ModalFooter mt="10px">
              <Button
                bg="yellow"
                color="white"
                mr={3}
                onClick={() => copyBlockHandler()}
              >
                Submit
              </Button>
              <Button color="white" variant="ghost" onClick={onClose2}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <Drawer
        isOpen={isOpen4}
        placement="right"
        onClose={onClose4}
        finalFocusRef={btnRef}
        size={"xs"}
      >
        <DrawerOverlay BG="#2A3843" />
        <DrawerContent bg="background.dark">
          <DrawerCloseButton color="white" m={2} />
          <DrawerHeader color="white">Comments</DrawerHeader>
          <Flex height="100vh" p={2} flexDir={"column"}>
            {!loading ? (
              <Flex
                flexDir="column"
                height="85vh"
                overflowY={"auto"}
                ref={commentsEndRef}
              >
                {comments &&
                  comments
                    .sort(
                      (a, b) => new Date(a.created_on) - new Date(b.created_on)
                    )
                    .map((com, id) => (
                      <Flex
                        // flexDir="column"
                        py="3px"
                        flexDir="column"
                        mt={1}
                        mr="3px"
                      >
                        <Flex fontSize="14px" color="white" alignItems="center">
                          <Avatar
                            size="sm"
                            bg="white"
                            key={id}
                            name={com?.author?.name}
                            color="#2D3842"
                            fontWeight="700"
                            mr={2}
                            border="1px solid #2D3842"
                          />
                          <Text>{com?.author?.name}&nbsp;&nbsp;&nbsp;</Text>
                          <Text>
                            <svg
                              width="5"
                              height="5"
                              viewBox="0 0 5 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.5"
                                cy="2.5"
                                r="2.5"
                                transform="matrix(-1 0 0 1 5 0)"
                                fill="white"
                              />
                            </svg>
                          </Text>
                          <Text color="grey1" ml={2}>
                            {com?.created_on?.split("T")[0]}{" "}
                            {com?.created_on
                              ?.split("T")[1]
                              .split(".")[0]
                              .slice(0, 5)}
                          </Text>
                        </Flex>
                        {/* <Text mr="6px" color="grey1" fontSize={'md'} cursor="pointer" onClick={() => collabRemoveHandler(collab)}>
              <BiTrash />
            </Text> */}

                        <Flex
                          border="2px solid #FFFFFF50"
                          color="white"
                          my={1}
                          px={2}
                          py={1}
                          borderRadius={"7px"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                        >
                          {/* <Text color="white" fontSize="14px"   >{com?.comment}</Text> */}

                          {editingCommentId === com.id ? (
                            <Input
                              color="white"
                              fontSize="14px"
                              type="text"
                              defaultValue={com.comment}
                              onChange={(e) =>
                                setEditCommentValue(e.target.value)
                              }
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  handleSaveComment(
                                    com?.id,
                                    editCommentValue
                                      ? editCommentValue
                                      : com?.comment
                                  );
                                  e.preventDefault(); // Prevent form submission if your Input is inside a form element
                                }
                              }}
                              autoFocus
                              variant="outline"
                              size="xs"
                            />
                          ) : (
                            <Text color="white" fontSize="14px">
                              {com.comment}
                            </Text>
                          )}

                          {/* <Flex>
                        <IconButton
                          icon={
                            editingCommentId === com.id ? (
                              <CheckIcon />
                            ) : (
                              <EditIcon />
                            )
                          }
                          onClick={() =>
                            editingCommentId === com.id
                              ? handleSaveComment(com.id, editCommentValue)
                              : handleEditComment(com.id)
                          }
                          variant="unstyled"
                          size="sm"
                        />
                        <IconButton
                          icon={<DeleteIcon />}
                          onClick={() => deleteComment(com.id)}
                          variant="unstyled"
                          size="sm"
                        />
                      </Flex> */}
                          <Popover>
                            <PopoverTrigger>
                              <IconButton
                                icon={<BiDotsVertical size={18} />}
                                variant="unstyled"
                                size="xs"
                              />
                            </PopoverTrigger>
                            <PopoverContent
                              width="100px"
                              bg="bg"
                              mr={4}
                              mb={2}
                              border="2px solid #FFFFFF50"
                              color="white"
                            >
                              {com?.is_author && (
                                <Box
                                  onClick={() => {
                                    editingCommentId === com.id
                                      ? handleSaveComment(
                                          com?.id,
                                          editCommentValue
                                            ? editCommentValue
                                            : com?.comment
                                        )
                                      : handleEditComment(com.id);

                                    return;
                                  }}
                                  cursor="pointer"
                                  _hover={{ bg: "grey2" }}
                                  p={1}
                                >
                                  {editingCommentId === com.id
                                    ? "Save"
                                    : "Edit"}
                                </Box>
                              )}
                              {com?.is_author && (
                                <Box
                                  onClick={() => deleteComment(com.id)}
                                  cursor="pointer"
                                  _hover={{ bg: "grey2" }}
                                  p={1}
                                >
                                  Delete
                                </Box>
                              )}
                              {/* <Box
                              onClick={() => console.log("resolve")}
                              cursor="pointer"
                              _hover={{ bg: "grey2" }}
                              p={2}
                            >
                              Resolve
                            </Box> */}
                              <Box
                                onClick={() => replyHandler(com?.id)}
                                cursor="pointer"
                                _hover={{ bg: "grey2" }}
                                p={2}
                              >
                                Add Reply
                              </Box>
                            </PopoverContent>
                          </Popover>
                        </Flex>
                        {com?.replies
                          ?.sort(
                            (a, b) =>
                              new Date(a.created_on) - new Date(b.created_on)
                          )
                          .map((reply, id) => (
                            <Flex
                              // flexDir="column"
                              py="3px"
                              flexDir="column"
                              ml={5}
                            >
                              <Flex
                                fontSize="12px"
                                color="white"
                                alignItems="center"
                              >
                                {/* <Avatar
                            size="xs"
                            bg="white"
                            key={id}
                            name={reply?.author?.name}
                            color="#2D3842"
                            fontWeight="700"
                            mr={2}
                            border="1px solid #2D3842"
                          /> */}
                                <Text>
                                  {reply?.author?.name}&nbsp;&nbsp;&nbsp;
                                </Text>
                                <Text>
                                  <svg
                                    width="5"
                                    height="5"
                                    viewBox="0 0 5 5"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="2.5"
                                      cy="2.5"
                                      r="2.5"
                                      transform="matrix(-1 0 0 1 5 0)"
                                      fill="white"
                                    />
                                  </svg>
                                </Text>
                                <Text color="grey1" ml={2}>
                                  {reply?.created_on?.split("T")[0]}{" "}
                                  {reply?.created_on
                                    ?.split("T")[1]
                                    .split(".")[0]
                                    .slice(0, 5)}
                                </Text>
                              </Flex>
                              {/* <Text mr="6px" color="grey1" fontSize={'md'} cursor="pointer" onClick={() => collabRemoveHandler(collab)}>
                <BiTrash />
              </Text> */}

                              <Flex
                                border="1px solid #FFFFFF50"
                                color="white"
                                my={1}
                                px={2}
                                py="2px"
                                borderRadius={"4px"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                              >
                                {/* <Text color="white" fontSize="14px"   >{reply?.comment}</Text> */}

                                {editingCommentId === reply.id ? (
                                  <Input
                                    color="white"
                                    fontSize="12px"
                                    type="text"
                                    defaultValue={reply?.comment}
                                    onChange={(e) =>
                                      setEditCommentValue(e.target.value)
                                    }
                                    onKeyPress={(e) => {
                                      if (e.key === "Enter") {
                                        handleSaveComment(
                                          reply?.id,
                                          editCommentValue
                                            ? editCommentValue
                                            : reply?.comment
                                        );
                                        e.preventDefault(); // Prevent form submission if your Input is inside a form element
                                      }
                                    }}
                                    autoFocus
                                    variant="outline"
                                    size="xs"
                                  />
                                ) : (
                                  <Text color="white" fontSize="12px">
                                    {reply.comment}
                                  </Text>
                                )}
                                {reply?.is_author && (
                                  <Popover>
                                    <PopoverTrigger>
                                      <IconButton
                                        icon={<BiDotsVertical size={18} />}
                                        variant="unstyled"
                                        size="xs"
                                      />
                                    </PopoverTrigger>
                                    <PopoverContent
                                      width="100px"
                                      bg="bg"
                                      mr={4}
                                      mb={1}
                                      border="2px solid #FFFFFF50"
                                      color="white"
                                    >
                                      <Box
                                        onClick={() =>
                                          editingCommentId === reply.id
                                            ? handleSaveComment(
                                                reply?.id,
                                                editCommentValue
                                                  ? editCommentValue
                                                  : reply?.comment
                                              )
                                            : handleEditComment(reply.id)
                                        }
                                        cursor="pointer"
                                        _hover={{ bg: "grey2" }}
                                        p={2}
                                      >
                                        {editingCommentId === reply.id
                                          ? "Save"
                                          : "Edit"}
                                      </Box>
                                      <Box
                                        onClick={() => deleteComment(reply.id)}
                                        cursor="pointer"
                                        _hover={{ bg: "grey2" }}
                                        p={2}
                                      >
                                        Delete
                                      </Box>
                                      {/* <Box
                                onClick={() => console.log("resolve")}
                                cursor="pointer"
                                _hover={{ bg: "grey2" }}
                                p={2}
                              >
                                Resolve
                              </Box> */}
                                    </PopoverContent>
                                  </Popover>
                                )}
                              </Flex>
                            </Flex>
                          ))}
                        {showInput && com?.id === addReviewId && (
                          <>
                            <InputGroup ml={5} width="92.5%">
                              <Input
                                placeholder="Add a reply"
                                bg="grey3"
                                color="white"
                                focusBorderColor="#FFFFFF80"
                                border="none"
                                autoFocus={true}
                                type="text"
                                fontSize={"12px"}
                                value={replyValue}
                                onChange={(e) => setReplyValue(e.target.value)}
                                onKeyPress={(e) => {
                                  if (
                                    e.key === "Enter" &&
                                    e.target.value.length > 1
                                  ) {
                                    setShowInput(!showInput);
                                    postComment(com?.id, replyValue);
                                    setReplyValue("");
                                    setAddReviewId(null);
                                  }
                                }}
                                autoComplete="off"
                              />
                              <InputRightElement width="3rem" height="100%">
                                <Button
                                  h="1.5rem"
                                  size="sm"
                                  onClick={() => {
                                    if (replyValue.length > 0) {
                                      setShowInput(!showInput);
                                      postComment(com?.id, replyValue);
                                      setReplyValue("");
                                      setAddReviewId(null);
                                    }
                                  }}
                                  bg="bg"
                                >
                                  <svg
                                    width="18"
                                    height="12"
                                    viewBox="0 0 18 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M0.25 6C0.25 5.83424 0.315848 5.67526 0.433058 5.55805C0.550268 5.44084 0.70924 5.375 0.875 5.375H15.6163L11.6825 1.4425C11.5651 1.32514 11.4992 1.16597 11.4992 0.999996C11.4992 0.834026 11.5651 0.674854 11.6825 0.557496C11.7999 0.440138 11.959 0.374207 12.125 0.374207C12.291 0.374207 12.4501 0.440138 12.5675 0.557496L17.5675 5.5575C17.6257 5.61555 17.6719 5.68452 17.7034 5.76045C17.7349 5.83639 17.7511 5.91779 17.7511 6C17.7511 6.0822 17.7349 6.16361 17.7034 6.23954C17.6719 6.31547 17.6257 6.38444 17.5675 6.4425L12.5675 11.4425C12.4501 11.5599 12.291 11.6258 12.125 11.6258C11.959 11.6258 11.7999 11.5599 11.6825 11.4425C11.5651 11.3251 11.4992 11.166 11.4992 11C11.4992 10.834 11.5651 10.6749 11.6825 10.5575L15.6163 6.625H0.875C0.70924 6.625 0.550268 6.55915 0.433058 6.44194C0.315848 6.32473 0.25 6.16576 0.25 6Z"
                                      fill="white"
                                    />
                                  </svg>
                                </Button>
                              </InputRightElement>
                            </InputGroup>{" "}
                          </>
                        )}
                      </Flex>
                    ))}
              </Flex>
            ) : (
              <Spinner m={3} />
            )}
            <Flex justifyContent={"space-between"} alignItems={"center"} py={2}>
              <Input
                placeholder="Add a comment"
                bg="background.grey3"
                color="white"
                focusBorderColor="#FFFFFF80"
                border="none"
                required={true}
                type="text"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && e.target.value.length > 1) {
                    postComment(-1, comment);
                    setComment("");
                  }
                }}
                mr={1}
                autoComplete="off"
              />

              <Button
                size="sm"
                _hover={{ bg: "inherit" }}
                onClick={() => {
                  if (comment?.length > 1) postComment(-1, comment);
                }}
                bg="bg"
              >
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 18 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.25 6C0.25 5.83424 0.315848 5.67526 0.433058 5.55805C0.550268 5.44084 0.70924 5.375 0.875 5.375H15.6163L11.6825 1.4425C11.5651 1.32514 11.4992 1.16597 11.4992 0.999996C11.4992 0.834026 11.5651 0.674854 11.6825 0.557496C11.7999 0.440138 11.959 0.374207 12.125 0.374207C12.291 0.374207 12.4501 0.440138 12.5675 0.557496L17.5675 5.5575C17.6257 5.61555 17.6719 5.68452 17.7034 5.76045C17.7349 5.83639 17.7511 5.91779 17.7511 6C17.7511 6.0822 17.7349 6.16361 17.7034 6.23954C17.6719 6.31547 17.6257 6.38444 17.5675 6.4425L12.5675 11.4425C12.4501 11.5599 12.291 11.6258 12.125 11.6258C11.959 11.6258 11.7999 11.5599 11.6825 11.4425C11.5651 11.3251 11.4992 11.166 11.4992 11C11.4992 10.834 11.5651 10.6749 11.6825 10.5575L15.6163 6.625H0.875C0.70924 6.625 0.550268 6.55915 0.433058 6.44194C0.315848 6.32473 0.25 6.16576 0.25 6Z"
                    fill="white"
                  />
                </svg>
              </Button>
            </Flex>
          </Flex>
        </DrawerContent>
      </Drawer>
      {/* this is the section for version control */}

      <Box
        borderLeft={isOpen5 && "2px solid #495661"}
        pl={1}
        bg="background.dark"
        w={isOpen5 ? "270px" : "0"}
        overflow="auto"
        transition="width 0.3s ease"
        position="fixed"
        style={{ zIndex: 100 }}
        right="0"
      >
        <Flex flexDir="column" p={1}>
          <Flex alignItems="center" justifyContent={"space-between"}>
            <Text fontSize="17px" color="white" fontWeight="bold">
              Version History
            </Text>
            {/* close button */}
            <Button
              bg="inherit"
              _hover={{ bg: "inherit" }}
              color="white"
              fontSize="14px"
              // mr="10px"
              onClick={onToggle5}
            >
              <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em">
                <path
                  fill="currentColor"
                  fillRule="evenodd"
                  d="M12.854 2.854a.5.5 0 00-.708-.708L7.5 6.793 2.854 2.146a.5.5 0 10-.708.708L6.793 7.5l-4.647 4.646a.5.5 0 00.708.708L7.5 8.207l4.646 4.647a.5.5 0 00.708-.708L8.207 7.5l4.647-4.646z"
                  clipRule="evenodd"
                />
              </svg>
            </Button>
          </Flex>
          <Flex height="100vh" overflow={"auto"} flexDir={"column"}>
            <Flex height="77vh" flexDir="column" color="white">
              {versions &&
                versions.map((version, index) => (
                  <Flex
                    id={index}
                    cursor={"pointer"}
                    m={1}
                    p={3}
                    fontSize={"14px"}
                    borderRadius={5}
                    onClick={() => versionClickHandler(version.id)}
                    bg={version.id === activeVersion ? "green" : "grey3"}
                  >
                    {version.version_date
                      ?.split("T")[1]
                      .split(".")[0]
                      .slice(0, 5)}
                    , &nbsp;
                    {version.version_date?.split("T")[0]}
                  </Flex>
                ))}
            </Flex>
            <Button
              bg="background.yellow1"
              p={1}
              px={2}
              color="white"
              fontSize="15px"
              // mr="10px"
              as="a"
              w="100%"
              onClick={() => restoreVersion(activeVersion)}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                  fill="white"
                />
                <path
                  d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                  fill="white"
                />
              </svg>
              &nbsp; Restore back to this version
            </Button>
            {/* <Button
                bg="#444d54"
                p={1}
                px={2}
                color="white"
                my={2}
                fontSize="13px"
                width="100%"
                // mr="10px"
                as="a"
                onClick={onOpen4}
              >
                <svg
                  width="16"
                  height="19"
                  viewBox="0 0 16 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4578 4.78426C14.8043 4.43776 14.9949 3.97759 14.9949 3.48809C14.9949 2.99859 14.8043 2.53843 14.4578 2.19193L13.0039 0.738094C12.6574 0.391594 12.1973 0.200928 11.7078 0.200928C11.2183 0.200928 10.7581 0.391594 10.4125 0.737178L0.666504 10.4529V14.5H4.71175L14.4578 4.78426ZM11.7078 2.03426L13.1625 3.48718L11.705 4.93918L10.2512 3.48626L11.7078 2.03426ZM2.49984 12.6667V11.2138L8.95317 4.78059L10.407 6.23443L3.95459 12.6667H2.49984ZM0.666504 16.3333H15.3332V18.1667H0.666504V16.3333Z"
                    fill="white"
                  />
                </svg>
                &nbsp; Create new block from this version
              </Button>{" "} */}
            <Button
              bg="#444d54"
              p={1}
              px={2}
              color="white"
              my={1}
              fontSize="14px"
              width="100%"
              // mr="10px"
              as="a"
              onClick={() => putVersion()}
            >
              &nbsp; Backup Now
            </Button>
          </Flex>
        </Flex>
      </Box>
      {/* <>
        <Drawer
          isOpen={isOpen5}
          placement="right"
          onClose={onClose5}
          finalFocusRef={btnRef2}
          size={"xs"}
        >
          <DrawerOverlay bg="inherit"  />

          <DrawerOverlay opacity="0" pointerEvents="none" />

          <DrawerContent bg="bg">
            <DrawerCloseButton color="white" m={2} />
            <DrawerHeader color="white">Version History</DrawerHeader>
            <Flex height="100vh" m={2} flexDir={"column"}>
              <Flex height="74vh" flexDir="column" color="white"  >
                {versions && versions.map((version, index) => (
                  <Flex id={index}   m={1} p={3} fontSize={"14px"} borderRadius={5} onClick={()=>versionClickHandler(version.id)} bg= {version.id===activeVersion?"green":'grey3'}>
                    {version.version_date
                          ?.split("T")[1]
                          .split(".")[0]
                          .slice(0, 5)},
                          &nbsp;
                {version.version_date?.split("T")[0]}
                  </Flex>  
                ))}
              </Flex>
              <Button
                bg="yellow1"
                p={1}
                px={2}
                color="white"
                fontSize="15px"
                // mr="10px"
                as="a"
                w="100%"
                onClick={() => (window.location = "/approval/" + pageSlug)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.29688 0.5625H9.70312C9.82812 0.5625 9.89062 0.625 9.89062 0.75V17.25C9.89062 17.375 9.82812 17.4375 9.70312 17.4375H8.29688C8.17187 17.4375 8.10938 17.375 8.10938 17.25V0.75C8.10938 0.625 8.17187 0.5625 8.29688 0.5625Z"
                    fill="white"
                  />
                  <path
                    d="M1.125 8.10938H16.875C17 8.10938 17.0625 8.17187 17.0625 8.29688V9.70312C17.0625 9.82813 17 9.89062 16.875 9.89062H1.125C1 9.89062 0.9375 9.82813 0.9375 9.70312V8.29688C0.9375 8.17187 1 8.10938 1.125 8.10938Z"
                    fill="white"
                  />
                </svg>
                &nbsp; Restore back to this version
              </Button>
              <Button
                bg="#444d54"
                p={1}
                px={2}
                color="white"
                my={2}
                fontSize="14px"
                width="100%"
                // mr="10px"
                as="a"
                onClick={onOpen5}
              >
                <svg
                  width="16"
                  height="19"
                  viewBox="0 0 16 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4578 4.78426C14.8043 4.43776 14.9949 3.97759 14.9949 3.48809C14.9949 2.99859 14.8043 2.53843 14.4578 2.19193L13.0039 0.738094C12.6574 0.391594 12.1973 0.200928 11.7078 0.200928C11.2183 0.200928 10.7581 0.391594 10.4125 0.737178L0.666504 10.4529V14.5H4.71175L14.4578 4.78426ZM11.7078 2.03426L13.1625 3.48718L11.705 4.93918L10.2512 3.48626L11.7078 2.03426ZM2.49984 12.6667V11.2138L8.95317 4.78059L10.407 6.23443L3.95459 12.6667H2.49984ZM0.666504 16.3333H15.3332V18.1667H0.666504V16.3333Z"
                    fill="white"
                  />
                </svg>
                &nbsp; Create new block from this version
              </Button>{" "}
              <Button
                bg="#444d54"
                p={1}
                px={2}
                color="white"
                my={2}
                fontSize="14px"
                width="100%"
                // mr="10px"
                as="a"
                onClick={() => putVersion()}
              >
                <svg
                  width="16"
                  height="19"
                  viewBox="0 0 16 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4578 4.78426C14.8043 4.43776 14.9949 3.97759 14.9949 3.48809C14.9949 2.99859 14.8043 2.53843 14.4578 2.19193L13.0039 0.738094C12.6574 0.391594 12.1973 0.200928 11.7078 0.200928C11.2183 0.200928 10.7581 0.391594 10.4125 0.737178L0.666504 10.4529V14.5H4.71175L14.4578 4.78426ZM11.7078 2.03426L13.1625 3.48718L11.705 4.93918L10.2512 3.48626L11.7078 2.03426ZM2.49984 12.6667V11.2138L8.95317 4.78059L10.407 6.23443L3.95459 12.6667H2.49984ZM0.666504 16.3333H15.3332V18.1667H0.666504V16.3333Z"
                    fill="white"
                  />
                </svg>
                &nbsp; Temp backup
              </Button>
            </Flex>
          </DrawerContent>
        </Drawer>
      </> */}
      <Modal isOpen={isOpen7} onClose={onClose7} isCentered>
        <ModalOverlay />
        <ModalContent bg="background.grey3" color="white">
          <ModalHeader>Upload New File</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontWeight="700" fontSize="18px" mb="10px">
              Upload File
            </Text>
            <label
              for="file_upload"
              style={{
                borderColor: "#6c757d",
                display: "block",
                width: "100%",
                borderWidth: "2px",
                borderStyle: "dashed",
                borderRadius: "5px",
                padding: "10px",
                textAlign: "center",
                fontSize: "1rem",
                cursor: "pointer",
                color: "#6c757d",
              }}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleFileDrop}
            >
              {fileName
                ? "File uploaded: " + fileName
                : "Select or drag a file"}
            </label>
            <Input
              id="file_upload"
              type="file"
              onChange={(e) => handleFileInput(e.target.files[0])}
            />
            {/* <FileUploader
              // multiple={true}
              style={{color:"white",fontSize:"18px",border:"none"}}
              multiple={false}
              handleChange={handleFileInput}
              name="file"
            />
             */}
            <Text fontWeight="700" fontSize="18px" mb="5px" mt="10px">
              Enter file description
            </Text>
            <Input placeholder="Enter file description" ref={descRef} />
          </ModalBody>

          <ModalFooter>
            <Button
              bg="background.yellow1"
              mr={3}
              isDisabled={fileURL === null}
              onClick={handleNewFile}
            >
              {filel ? "Uploading..." : "Submit"}
            </Button>
            <Button variant="ghost" onClick={onClose7}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <>
        <Modal
          isOpen={isOpen6}
          onClose={() => {
            setFileName("");
            onClose();
          }}
          isCentered
        >
          <ModalOverlay />
          <ModalContent bg="grey3" color="white">
            <ModalHeader>Upload New File</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Text fontWeight="700" fontSize="18px" mb="10px">
                Upload File
              </Text>
              <label
                for="file_upload"
                style={{
                  borderColor: "#6c757d",
                  display: "block",
                  width: "100%",
                  borderWidth: "2px",
                  borderStyle: "dashed",
                  borderRadius: "5px",
                  padding: "10px",
                  textAlign: "center",
                  fontSize: "1rem",
                  cursor: "pointer",
                  color: "#6c757d",
                }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleFileDrop}
              >
                {fileName
                  ? "File uploaded: " + fileName
                  : "Select or drag a file"}
              </label>
              <Input
                id="file_upload"
                type="file"
                onChange={(e) => handleFileInput(e.target.files[0])}
              />
              {/* <FileUploader
              // multiple={true}
              style={{color:"white",fontSize:"18px",border:"none"}}
              multiple={false}
              handleChange={handleFileInput}
              name="file"
            />
             */}
              <Text fontWeight="700" fontSize="18px" mb="5px" mt="10px">
                Enter file description
              </Text>
              <Input placeholder="Enter file description" ref={descRef} />
            </ModalBody>

            <ModalFooter>
              <Button
                bg="yellow1"
                mr={3}
                isDisabled={fileURL === null}
                onClick={handleNewFile}
              >
                {filel ? "Uploading..." : "Submit"}
              </Button>
              <Button
                variant="ghost"
                onClose={() => {
                  setFileName("");
                  onClose();
                }}
              >
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
      <Modal isOpen={isOpen8} onClose={onClose8} isCentered>
        <ModalOverlay />
        <ModalContent bg="background.grey3" color="white">
          <ModalHeader>Add link to a New File</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontWeight="700" fontSize="18px" mb="5px" mt="10px">
              Enter file title
            </Text>
            <Input
              placeholder="Enter file title"
              ref={fiTitle}
              maxLength="40"
            />
            <Text fontWeight="700" fontSize="18px" mb="5px" mt="10px">
              Add link to file
            </Text>
            <Input placeholder="Enter file link" ref={fileRef} />
            <Text fontWeight="700" fontSize="18px" mb="5px" mt="10px">
              Enter file description
            </Text>
            <Input placeholder="Enter file description" ref={descRef2} />
          </ModalBody>

          <ModalFooter>
            <Button bg="background.yellow1" mr={3} onClick={sendGoogleDoc}>
              Submit
            </Button>
            <Button variant="ghost" onClick={onClose8}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        bg="#444d54"
        isOpen={isOpen9}
        onClose={onClose9}
        isCentered
        size="xl"
      >
        <ModalOverlay BG="#0000004D" />
        <ModalContent bg="#444d54">
          <ModalHeader color="white">AI Summary</ModalHeader>
          <ModalBody>
            <Flex flexDir="column" mb="10px">
              <Text color="white">
                This is the summary of the project generated by our AI model.
              </Text>

              <Text
                color="black"
                fontWeight="400"
                border="2px solid grey"
                py="13px"
                px="8px"
                borderRadius="5px"
                fontSize="15px"
                bg="white"
                my={1}
                h="350px"
                overflowY="auto"
              >
                {summary !== null ? summary : <Spinner />}
              </Text>
            </Flex>
          </ModalBody>

          <ModalFooter mt="10px">
            <Button
              bg="background.yellow1"
              color="white"
              fontSize="14px"
              mr="10px"
              onClick={generateSummaryHandler}
            >
              Generate Now
            </Button>
            <Button color="white" variant="ghost" onClick={onClose9}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Page;
